import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { whatsapp, telegram } from "./constans/ColorConstants";

const loadStoredLang = () => {
  try {
    return localStorage.getItem("lang") || undefined;
  } catch {
    return undefined;
  }
};

const resources = {
  // 英国：英语
  en: {
    translation: {
      header: {
        about: "About",
        shop: "Shop",
        lab: "Lab results",
        calculator: "Calculator",
        help: "Help Center",
        cartAria: "Cart",
        accountAria: "Account",
        searchAria: "Search",
        cartTitle: "Cart",
        searchPlaceholder: "Keep typing to search...",
      },
      footer: {
        information: "Information",
        bestSellers: "Best‑selling products",
        cooperation: "Cooperation",
        ourSocials: "Our socials",
        links: {
          calculator: "Peptide Calculator",
          help: "Help Center",
          terms: "General Terms and Conditions",
          refund: "Return and refund policy",
          privacy: "Privacy Policy",
          contact: "Contact",
          bulk: "Bulk purchasing",
          partner: "Become a partner",
          shipping: "Shipping",
        },
        langEnglish: "English",
        langDutch: "Dutch",
        langGerman: "German",
        langFrench: "French",
        promoFreeShip: "Free shipping on EU orders over €250",
        entryGate: {
          title: "Choose your settings",
          subtitle:
            "Our products are for research purposes only. Please follow your country-specific legal guidelines.",
          deliveryCountry: "Delivery Country",
          language: "Language",
          searchCountry: "Search countries...",
          languagePlaceholder: "Select a language...",
          ageQuestion: "Are you 18+ or older?",
          ageYes: "Yes, I am 18+",
          ageNo: "No",
          researchLabel:
            "I confirm that these products will be used exclusively for research purposes.",
          continue: "Continue",
          cookiePrefix: "By continuing you accept the use of cookies. ",
          privacyPolicy: "Privacy Policy",
          accessDeniedTitle: "Access Denied",
          accessDeniedBody: "You must be 18 or older to access this website.",
          countries: {
            NL: "Netherlands",
            BE: "Belgium",
            DE: "Germany",
            FR: "France",
            GB: "United Kingdom",
          },
        },
      },
      main: {
        hero: {
          title_white: "Research Grade Peptides",
          title_yellow: "For Consistent Results",
          cta: "Shop Peptides",
          telegram_title: "Join our Telegram",
          telegram_text: "for exclusive deals",
        },
        marquee: ["99% PURITY", "DUTCH QUALITY", "FOR RESEARCH PURPOSES ONLY"],
        categoriesTitleLight: "All",
        categoriesTitleAccent: "Categories",
        categories: {
          fat_burning: "Fat burning",
          muscle_building: "Muscle building",
          serums: "Serums",
          mental_focus: "Mental focus",
          hormonal_support: "Hormonal support",
          recovery: "Recovery",
          cosmetic: "Cosmetic",
          supplies: "Supplies",
        },
        productsTitleLight: "Popular Peptides in our",
        productsTitleAccent: "Research Catalog",
        productsText: "All compounds are batch-tested and shipped discreetly",
        viewAll: "View all peptides",
        priceFrom: "From {{price}}",
        buttons: {
          addToCart: "ADD TO CART",
          selectOptions: "SELECT OPTIONS",
          view: "VIEW",
          badgeFreeBox: "• FREE PEPTIDE STORAGE BOX",
        },
        aria: {
          previous: "Previous",
          next: "Next",
          goSlide: "Go to slide {{n}}",
          goPage: "Go to page {{n}}",
          hero: "Hero",
          categories: "Categories",
          newPeptides: "New Peptides",
          about: "About Puritybase",
          reasons: "Why choose Puritybase",
          telegram: "Join our Telegram",
        },
        empty: "No products found.",
        about: {
          titleLight: "About",
          titleAccent: "Puritybase",
          p1: "At Puritybase, we are committed to providing researchers with high‑quality, pharmaceutical‑grade peptides that meet the highest standards of purity and reliability. Our mission is to advance scientific progress by supplying products that enable accurate, consistent, and dependable results.",
          p2: "Every peptide in our catalogue is independently tested and comes with a Certificate of Analysis (COA) to ensure transparency and trust. We believe researchers deserve products that are not only effective, but also safe, consistent, and carefully delivered.",
        },
        reasonsTitleAccent: "Why Researchers Choose Puritybase",
        reasonsText: [
          "We provide European-manufactured peptides with ≥99% verified purity. Every batch is independently tested and comes with a Certificate of Analysis.",
          "Join our Telegram community for exclusive deals, research updates, and direct support from our team.",
        ],
        reasons: [
          {
            title: "Lab Tested",
            desc: "All products tested for purity and quality",
          },
          {
            title: "Same Day Shipping",
            desc: "Quick delivery throughout Europe",
          },
          {
            title: "Handling Guidance",
            desc: "Expert advice on product handling",
          },
          {
            title: "Customer Service",
            desc: "Dedicated support for all inquiries",
          },
        ],
        telegram: {
          title: "Get exclusive deals on Telegram",
          text: "Join our Telegram channel and be the first to receive private discounts, limited-time offers, and insider updates you won't find anywhere else.",
          btn: "Join",
        },
      },
      aboutPage: {
        hero: {
          aria: "About Puritybase",
          breadcrumbAria: "Breadcrumb",
          breadcrumb: "Home",
          titlePrefix: "About",
          titleBrand: "Puritybase",
          text: "At Puritybase, we are committed to providing researchers with high-quality pharmaceutical-grade peptides that meet the strictest standards for purity and reliability. Our mission is to support scientific advancement by offering products that enable accurate, consistent, and reliable results.",
        },
        pledge: {
          aria: "Our Promise",
          title: "Our Promise",
          item1: "Pharmaceutical-grade research peptides",
          item2: "Safe and discreet delivery across Europe",
          item3: "Verified purity and lab-tested batches",
          item4: "Dedicated service to support your research",
        },
        why: {
          aria: "Why Choose Puritybase",
          title: "Why Choose Puritybase",
          text: "We deliver pharmaceutical-grade peptides, independently tested and accompanied by a Certificate of Analysis (COA). With fast and discreet worldwide shipping, secure payments, and professional packaging, we guarantee quality and trust with every order. Our team is committed to compliance, reliability, and dedicated customer service.",
          card1Title: "Scientific Integrity",
          card1Desc:
            "Every peptide is HPLC-tested for ≥99% purity, ensuring reliable and reproducible research results.",
          card2Title: "Confidential & Compliant",
          card2Desc:
            "For research purposes only. Secure, discreet packaging with full regulatory compliance.",
          card3Title: "Fast Delivery",
          card3Desc: "Receive a tracking code within 24 hours of your order.",
        },
      },
      shop: {
        title: "Shop",
        heroTitle: "Shop All Products",
        heroSubtitle:
          "Browse our complete collection of premium research peptides.",
        breadcrumb: "Home",
        breadcrumbAria: "Breadcrumb",
        categoriesAria: "Product categories",
        searchPlaceholder: "Search products...",
        sortBy: "Sort by:",
        sortNewest: "Newest",
        sortPriceAsc: "Price: Low to High",
        sortPriceDesc: "Price: High to Low",
        viewBtn: "VIEW",
        saleBadge: "Sale",
        promoBanner: "+ FREE PEPTIDE STORAGE BOX",
        emptyTitle: "No products found",
        emptyDesc: "Try a different category or search.",
        clearFilters: "Clear filters",
        filtersTitle: "Filters",
        toggleFiltersAria: "Toggle filters",
        productsAria: "Products",
        selectOptions: "SELECT OPTIONS",
        categories: {
          all: "All",
          anti_aging: "Anti‑aging",
          bundles: "Bundles",
          pens: "Pens",
          serums: "Serums",
          fat_burning: "Fat burning",
          muscle_building: "Muscle building",
          recovery: "Recovery",
          cosmetic: "Cosmetic",
          hormonal_support: "Hormonal Support",
          mental_focus: "Mental focus",
          supplies: "Supplies",
        },
      },
      lab: {
        title: "Test results",
        breadcrumb: "Home",
        breadcrumbAria: "Breadcrumb",
        heroTitle: "Lab Results",
        heroSubtitle:
          "Independent third-party testing results for all our peptides",
        aria: {
          testCategories: "Test categories",
          reports: "Reports",
          resultsTable: "Results table",
          moreTestCategories: "More test categories",
        },
        table: {
          type: "Test type",
          result: "Result",
        },
        tabs: {
          nad_500: "NAD+ 500",
          tirzepatide_30mg: "Tirzepatide 30mg",
          tirzepatide_10mg: "Tirzepatide 10mg",
          retatrutide_30mg: "Retatrutide 30mg",
          retatrutide: "Retatrutide",
          tirzepatide: "Tirzepatide",
          semaglutide: "Semaglutide",
          ghk_cu: "GHK-Cu",
          glow70: "GLOW70",
          klow80: "KLOW80",
          tb_500: "TB-500",
          melanotan_ii: "Melanotan-II",
          igf1_lr3: "IGF-1 LR3",
          cjc_no_dac: "CJC 1295 without DAC",
          ipamorelin: "Ipamorelin",
          selank: "Selank",
          semax: "Semax",
        },
        labels: {
          contentMeasured: "Content (measured)",
          amountMeasured: "Amount (measured)",
          purityHPLC: "Purity (HPLC)",
          purity: "Purity",
          heavyMetals: "Heavy metals",
          endotoxins: "Endotoxins",
          laboratory: "Laboratory",
          taskNumber: "Task number",
          verificationCode: "Verification code",
          analysisDate: "Analysis date",
          verification: "Verification",
          peptide: "Peptide",
        },
        values: {
          testedWithinSpecs: "Tested - within specifications",
          underAnalysis: "Under analysis / coming soon",
          notTested: "Not tested",
          verifyTestReport: "Verify test report",
          viewVerifyReport: "View and verify the test report",
        },
      },
      calculator: {
        title: "Peptide Calculator",
        aria: {
          section: "Calculator",
        },
        labels: {
          syringeVolume: "What is the total volume of your syringe?",
          vialMg: "How many mg is in the vial?",
          waterMl: "How much bacteriostatic water do you add?",
          doseMg: "How many mg do you want to dose?",
        },
        buttons: {
          other: "Other",
        },
        alt: {
          vial: "vial",
          water: "bacteriostatic water",
          syringe: "{{v}} ml syringe",
        },
        result: {
          prefix: "To get a dose of",
          suffix: "draw the syringe to",
        },
      },
      help: {
        title: "Help Center",
        intro1: "Welcome to the Puritybase Help Center.",
        intro2:
          "Here you will find answers to the most frequently asked questions about ordering, shipping, returns, and our products.",
        sections: [
          {
            key: "pay", 
            title: "🛒 Ordering & Payment",
            faqs: [
              {
                q: "What payment methods do you offer?",
                a: [
                  "You can pay safely and easily with the most popular European payment options.",
                  "All payments are processed via a secure SSL connection and are processed immediately."
                ],
              },
              {
                q: "Is my payment confirmed immediately?",
                a: [
                  "Yes. Once payment is complete, you will automatically receive an <strong>order confirmation by email</strong>.",
                  "Didn't receive an email within a few minutes? Check your spam folder or contact us.",
                ],
              },
              {
                q: "How is my order packaged?",
                a: [
                  "All orders are shipped in <strong>discrete, neutral packaging</strong> without any product names or logos visible on the outside.",
                  "Inside, your products are professionally packed to ensure they arrive in perfect condition."
                ],
              },
            ],
          },
          {
            key: "ship", 
            title: "🚚 Shipping",
            faqs: [
              {
                q: "Which countries do you ship to?",
                a: [
                  "We ship <strong>from the Netherlands</strong> to all countries within the European Union.",
                  "Estimated delivery times:",
                  "• <strong>Netherlands & Belgium:</strong> 1-2 business days",
                  "• <strong>Germany, France, Luxembourg, Austria:</strong> 2-4 business days",
                  "• <strong>Spain, Italy, Portugal:</strong> 3-6 business days",
                  "• <strong>Scandinavia</strong> (Sweden, Denmark, Finland, Norway): 4-7 business days"
                ],
              },

              {
                q: "What are the shipping costs?",
                a: [
                  "Shipping costs are automatically calculated at checkout:",
                  "• <strong>Netherlands:</strong> €4.95",
                  "• <strong>Belgium:</strong> €9.95",
                  "• <strong>Germany:</strong> €9.95",
                  "• <strong>France:</strong> €9.95",
                  "<br />",
                  "• <strong>Other European countries:</strong> €14.95",
                  "<br />",
                  "<strong>Orders over €250 ship FREE within the EU!</strong>"
                ],
              },
              {
                q: "Will I receive a track & trace link?",
                a: [
                  "Yes! As soon as your order is shipped, you will automatically receive an email with the <strong>track & trace link</strong> so you can follow your package in real-time.",
                ],
              },
              {
                q: "What if my order is delayed or lost?",
                a: [
                  "If your order hasn't arrived within the expected delivery time, please contact us within <strong>10 business days</strong> of placing your order.",
                  "<br />",
                  "We will immediately start an investigation with the carrier and ensure you receive a <strong>full refund or free reshipment</strong>."
                ],
              },
            ],
          },
          {
            key: "return", 
            title: "↩️ Returns & Refunds",
            faqs: [
              {
                q: "Do you accept returns?",
                a: [
                  "No. We do not accept returns. All sales are final. Please review your order carefully before completing your purchase.",
                ],
              },
              {
                q: "Can I get a refund?",
                a: [
                  "We do not issue refunds for change of mind or unwanted items. If your order arrived damaged or incorrect, please contact us within 48 hours of delivery with photos and your order number.",
                ],
              },
              {
                q: "Can I exchange a product?",
                a: [
                  "We do not offer product exchanges."
                ],
              },
            ],
          },
          {
            key: "contact", 
            title: "💬 Contact & Support",
            faqs: [
              {
                q: "Comment puis-je vous contacter ?",
                a: [
                  "Nous proposons plusieurs façons de nous joindre :",
                  "<br />",
                  "📧 <strong>E-mail :</strong> info@example.com",
                  "→ Réponse sous 2-3 jours ouvrables",
                  "<br />",
                  "📝 <strong>Formulaire de contact :</strong> Sur notre site web",
                  "→ Réponse sous 2-3 jours ouvrables",
                  "<br />",
                  "💬 <strong>Telegram :</strong>",
                  "→ Réponse sous 2-3 heures (le plus rapide !)",
                  "<br />",
                  "Pour les questions urgentes, Telegram est votre meilleure option !"
                ],
              },
              {
                q: "Quelles sont vos heures d'ouverture ?",
                a: [
                  "Notre équipe de service client est disponible :",
                  "<br />",
                  "<strong>Lundi - Vendredi :</strong> 9h00 - 17h00 CET",
                  "<br />",
                  "Le support Telegram a une disponibilité étendue et répond généralement beaucoup plus rapidement que l'e-mail."
                ],
              },
            ],
          },
        ],
      },
      terms: {
        title: "Terms & Conditions",
        breadcrumb: "Home",
        breadcrumbAria: "Breadcrumb",
        lastUpdated: "Last updated: January 2025",
        intro:
          "The provisions below apply to your use of this website and every order you place.",
        sections: [
          {
            title: "1. General",
            body: "These terms and conditions apply to all offers, orders, and agreements made through our website.",
          },
          {
            title: "2. Prices",
            body: "All prices are in Euros and include VAT. Prices are subject to change without notice.",
          },
          {
            title: "3. Ordering",
            body: "By placing an order, you agree to these terms and conditions.",
          },
          {
            title: "4. Payment",
            body: "Payment must be made before shipment. We accept various payment methods including iDEAL, credit card, and PayPal.",
          },
          {
            title: "5. Delivery",
            body: "We ship within 1-2 business days. Delivery times depend on your location.",
          },
        ],
      },
      refunds: {
        breadcrumb: "Home",
        breadcrumbAria: "Breadcrumb",
        badgeBrand: "KING'S ACCESS",
        badgePoints: "214 PTS",
        title: "Returns and Refunds Policy",
        intro:
          "At Puritybase, quality, safety, and customer satisfaction are paramount. Due to the nature of our products, we maintain a strict but fair policy focused on product safety and rapid resolution of any issues.",
        sections: [
          {
            title: "No returns on peptides",
            paragraphs: [
              "Due to the nature of peptides and laboratory chemicals, returns are not possible. Once an order has been shipped, the product cannot be resold or re-inspected for sterile conditions.",
              "This policy is necessary to ensure the safety of our customers and the integrity and purity of our products. By placing an order, you agree to this policy.",
            ],
          },
          {
            title: "Damaged delivery or broken vial",
            paragraphs: [
              "If your order arrived damaged or contains a broken vial, please contact us within 48 hours of delivery by email or <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> and attach clear photos.",
              "<strong>Requirements:</strong>",
            ],
            list: [
              "clear photos of the product",
              "clear photos of the original packaging",
              "clear photos of the visible damage",
            ],
            paragraphsTail: [
              "In these cases, we will send a replacement shipment free of charge. This is our standard solution to help you as quickly as possible.",
            ],
          },
          {
            title: "Refund (only after second shipment)",
            paragraphs: ["A refund is only possible if:"],
            list: [
              "there has been two shipments (the original shipment + a free replacement shipment), and",
              "if there is a problem again during the second shipment (for example, damage or a broken vial).",
            ],
            paragraphsTail: [
              "In that exceptional case, we offer a full refund.",
              "In other words, we always send a replacement product first; only in the event of repeated failure will a refund be considered.",
            ],
          },
          {
            title: "Conditions for replacement and possible refund",
            list: [
              "Damage must be reported within 48 hours of delivery",
              "Photos of the damaged product and original packaging are required",
              "Products must be unused and in original condition",
              "In some cases you may be asked to return the damaged item for verification.",
            ],
          },
          {
            title: "Incorrectly entered shipping address",
            paragraphs: [
              "Always check your shipping information carefully. If an order cannot be delivered due to an incorrect or incomplete address, we cannot guarantee a replacement or refund.",
            ],
          },
          {
            title: "Contact",
            paragraphs: [
              "Do you have questions or is there a problem with your order? Please contact us by email or <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a>. We are always happy to assist you within the framework of this policy.",
            ],
            email: "info@hgppeps.com",
          },
        ],
      },
      privacy: {
        title: "Privacy Policy",
        breadcrumb: "Home",
        breadcrumbAria: "Breadcrumb",
        lastUpdated: "Last updated: January 2025",
        intro: "Your privacy is important to us.",
        sections: [
          {
            title: "1. Data Collection",
            body: "We collect information you provide when placing orders, including name, email, and shipping address.",
          },
          {
            title: "2. Data Usage",
            body: "We use your data to process orders, send updates, and improve our services.",
          },
          {
            title: "3. Data Protection",
            body: "We implement security measures to protect your personal information.",
          },
          {
            title: "4. Cookies",
            body: "We use cookies to improve your browsing experience. You can manage cookie preferences in your browser.",
          },
          {
            title: "5. Your Rights",
            body: "You have the right to access, correct, or delete your personal data. Contact us for requests.",
          },
        ],
      },
      shippingPage: {
        breadcrumb: "Home",
        breadcrumbAria: "Breadcrumb",
        badgeBrand: "KING'S ACCESS",
        badgePoints: "214 PTS",
        title: "Shipping Information",
        subtitle: "Fast and reliable delivery across Europe",
        promoAria: "Free shipping offer",
        promoLead: "Free Shipping: ",
        promoDetail: "On all orders over €250 within the EU",
        colDestination: "Destination",
        colStandard: "Standard",
        colExpress: "Express",
        rows: [
          {
            destination: "Netherlands",
            standardDays: "1-2 days",
            standardPrice: "€4.95",
            express: "",
          },
          {
            destination: "Belgium",
            standardDays: "2-3 days",
            standardPrice: "€9.95",
            express: "",
          },
          {
            destination: "Germany",
            standardDays: "2-4 days",
            standardPrice: "€14.95",
            express: "",
          },
          {
            destination: "Other EU",
            standardDays: "3-7 days",
            standardPrice: "€14.95",
            express: "",
          },
        ],
        processTitle: "Shipping Process",
        processBody:
          "Orders placed before 2 PM on business days are shipped the same day.",
        trackingTitle: "Tracking",
        trackingBody:
          "You will receive a tracking link by email once your order has been shipped.",
      },
      contact: {
        title: "Need Help? We Are Here For You",
        intro:
          "From product questions to help with orders or information about compliance – our dedicated team is ready to guide you every step of the way.",
        helpBtn: "HELP CENTER",
        cards: {
          hoursTitle: "Customer Service Opening Hours",
          hoursText:
            "Monday – Friday: 09:00 – 17:00 (Exception: public holidays)",
          contactTitle: "Contact & Support",
          contactIntro:
            "Our customer service is ONLY available on <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> and <a class='privacy__link' href='" + telegram + "' target='_blank' rel='noopener noreferrer'>Telegram</a>!",
          whatsapp: "WhatsApp(1–2 hours)",
          telegram: "Telegram(1–2 hours)",
        },
      },
      bulk: {
        breadcrumbHome: "Home",
        title: "Bulk purchasing",
        intro:
          "Looking for bulk purchases for research purposes? We supply larger volumes for labs, resellers, and research projects. Pickup is also available by appointment.",
        form: {
          title: "Request a Quote",
          nameLabel: "Full Name",
          emailLabel: "Email Address",
          requestLabel: "Your Request",
          namePlaceholder: "Your name",
          emailPlaceholder: "you@example.com",
          requestPlaceholder:
            "Please include: product(s), desired amount (mg / number of vials), and preference (shipping or pick-up)",
          submit: "Send Request",
          submitting: "Sending…",
          submitSuccess: "Thank you — your request has been sent.",
          submitError: "Something went wrong. Please try again in a moment.",
          requiredStar: "*",
        },
        sections: [
          {
            title: "Who is bulk purchasing suitable for?",
            list: [
              "Laboratories & research institutions",
              "Partners / resellers (on request)",
              "Larger research projects with recurring purchases",
            ],
          },
          {
            title: "What you can expect from us",
            list: [
              "Graduated discount for higher purchases",
              "Consistent batch quality (where available with lab results/COA)",
              "Discreetly packaged or collect personally by appointment",
              "Fast communication and clear agreements",
            ],
          },
          {
            title: "How does it work?",
            ordered: [
              "Send your request with product(s), quantity and preference (shipping or pick-up)",
              "We check stock, batches and options",
              "You will receive a competitive quote + delivery time",
              "After approval we will arrange shipping or collection",
            ],
          },
          {
            title: "General volume discount",
            boxed: true,
            paragraphs: ["<strong>Minimum order quantity:</strong>"],
            list: [
              "10 pieces per product: <strong>30% discount</strong>",
              "20 pieces per product: <strong>35% discount</strong>",
              "30 pieces per product: <strong>40% discount</strong>",
            ],
            tail: [
              "A mix of multiple products can always be discussed together!",
            ],
          },
        ],
      },
      partner: {
        breadcrumbHome: "Home",
        title: "Become a Partner",
        intro:
          "Partner with Puritybase and earn money from high-quality research products. Our partner program is designed for creators, communities, and professionals who want to collaborate transparently and professionally.",
        form: {
          title: "Apply to Become a Partner",
          nameLabel: "Full Name",
          emailLabel: "Email Address",
          platformLabel: "Platform / Website",
          messageLabel: "Message",
          namePlaceholder: "Your name",
          emailPlaceholder: "you@example.com",
          platformPlaceholder: "Your website or social media channel",
          messagePlaceholder: "Tell us about your platform and audience",
          submit: "Submit Application",
          submitting: "Sending…",
          submitSuccess: "Thank you — your application has been sent.",
          submitError: "Something went wrong. Please try again in a moment.",
          requiredStar: "*",
        },
        sections: [
          {
            title: "Why become a partner?",
            list: [
              "Attractive commissions per successful referral",
              "Real-time insight into clicks, conversions and revenue",
              "Personal affiliate links and (optional) discount codes",
              "Fast and reliable payouts",
              "Collaborating with a fast-growing premium brand",
            ],
          },
          {
            title: "Who is this program for?",
            listLead: "Our affiliate program is suitable for:",
            list: [
              "Educational content creators",
              "Fitness, biohacking & research communities",
              "Coaches and informative platforms",
              "Websites and social media channels with a relevant target group",
            ],
          },
          {
            title: "How does it work?",
            ordered: [
              "Register via our partner portal",
              "Get your personal affiliate link",
              "Share Puritybase on your platform",
              "Earn commission on every qualifying order",
            ],
          },
          {
            title: "Transparent & Professional",
            boxed: true,
            paragraphs: [
              "We attach great value to correct communication, clear disclaimers, compliance with laws and regulations, and long-term partnerships. Collaborations are solely for informational and promotional purposes. Our products are for research purposes (in vitro) only.",
            ],
          },
        ],
      },
      pd: {
        crumbs: { home: "Home", products: "Products", category: "Recovery" },
        labels: {
          concentration: "Concentration (mg)",
          water: "3ml water",
          waterStd: "(supplied as standard)",
          needles: "Insulin : needles",
          needlesNone: "None",
          needle05: "10x 0.5ml insulin needle",
          needle1: "10x 1ml insulin needle",
          wipes: "Alcohol wipes",
          yes: "Yes",
          no: "No",
          clear: "Delete",
        },
        purchase: {
          quantity: "Quantity",
          price: "Price",
          decreaseQty: "Decrease quantity",
          increaseQty: "Increase quantity",
          inStock: "In stock",
          addToCart: "ADD TO CART",
        },
        shipping: {
          b1: "Delivery within 1 business day",
          b2: "Pickup at collection point available",
          b3: "Discreetly packaged",
          securePayments: "Secure payments",
        },
        cutoff: {
          headline: "Order before {{time}} for same-day shipping",
          within: "Order within",
          hours: "hours",
          minutes: "minutes",
          ordered: "Ordered",
          shipped: "Shipped",
          delivered: "Delivered",
          today: "Today",
          nextDay: "Next Day",
          countryAria: "Shipping country or region",
          countryUk: "United Kingdom",
          countryNl: "Netherlands",
        },
        tabs: {
          desc: "DESCRIPTION",
          ship: "SHIPPING & DELIVERY",
          lab: "LAB RESULTS",
          use: "USAGE & DISCLAIMER",
        },
        desc: {
          p1: "<strong>GHK‑Cu</strong> is a copper‑binding tripeptide consisting of <strong>3 amino acids</strong> (glycyl‑L‑histidyl‑L‑lysine) linked to a copper ion (Cu<sup>2+</sup>). Within a research context, this molecule is known for its role in cell communication and regenerative research.",
          p2: "GHK‑Cu is being investigated in scientific settings due to interactions with processes related to <strong>tissue remodeling</strong>, <strong>collagen synthesis</strong>, <strong>cell repair</strong>, and oxidative stress regulation.",
          relev: "Research relevance",
          list: [
            "Investigated within models regarding skin and connective tissue regeneration.",
            "Relevance within studies on collagen and extracellular matrix processes.",
            "Studied in relation to oxidative stress and cell communication.",
            "Applied within experimental research setups concerning regenerative mechanisms.",
          ],
          specTitle: "Important specifications",
          specHeadKey: "Feature",
          specHeadVal: "Value / note",
          specRows: [
            ["Peptide type", "Copper‑binding tripeptide (GHK‑Cu)"],
            ["Amino acid count", "3"],
            ["Available variants", "50mg, 100mg"],
          ],
        },
        shipTab: {
          ukRegion: "<strong>United Kingdom:</strong> {{nextDay}} · {{price}}",
          nlBeRegion: "<strong>The Netherlands &amp; Belgium:</strong> 1–2 working days · {{price}}",
          restEurope: "<strong>Rest of Europe:</strong> 3–7 working days · {{price}}",
          originNote: "Shipping from the Netherlands · Discreetly packaged · Track &amp; trace included",
          freeShippingUk: "<strong>Free shipping</strong> on orders over <strong>{{threshold}}</strong>",
          freeShippingEu: "<strong>Free shipping</strong> on orders over <strong>{{threshold}}</strong>",
        },
        labTab: {
          p1: "Our products are independently tested by an external laboratory. The corresponding test reports, including verification codes, are publicly available.",
          link: "View our lab results",
        },
        useTab: {
          list: [
            "Intended for <strong>research purposes only</strong>.",
            "Not for human use, diagnosis or treatment.",
            "For use by qualified personnel in a controlled research environment only.",
            "By purchasing this product you confirm you have taken note of these conditions and follow appropriate research practices.",
          ],
        },
        related: "Related products",
      },
      drawer: {
        ariaCart: "Cart",
        close: "Close",
        remove: "Remove",
        subtotal: "SUBTOTAL:",
        viewCart: "VIEW SHOPPING CART",
        checkout: "TO SETTLE",
        freeShipping: "You qualify for free shipping!",
        freeShippingMore: "{{amount}} more for free shipping",
        securePayments: "Secure payments",
        qtyDecrease: "Decrease quantity",
        qtyIncrease: "Increase quantity",
      },
      checkout: {
        title: "Checkout",
        aria: {
          billing: "Billing details",
          order: "Your order",
          contact: "Contact",
          delivery: "Delivery",
        },
        labels: {
          firstName: "First name *",
          lastName: "Last name *",
          email: "Email address *",
          country: "Country/region *",
          phoneOptional: "Phone (optional)",
          postalCode: "Postal code *",
          province: "Province *",
          city: "City *",
          street: "Street *",
        },
        order: {
          title: "Your order",
          product: "Product",
          subtotal: "Subtotal",
          shipping: "Shipping",
          total: "Total",
          qtyLabel: "Quantity",
          shippingMethod: "Shipping method",
          carrierLaPoste: "Royal Mail Tracked 24®",
          shippingFree: "Free",
        },
        payNow: "Pay now",
        validation: {
          email: {
            invalid: "Please enter a valid email address",
            required: "Please enter your email address",
          },
          firstName: { required: "Please enter your first name" },
          lastName: { required: "Please enter your last name" },
          zipCode: {
            required: "Please enter your postal code",
            invalid: "Please enter a valid postal code",
          },
          state: { required: "Please select a state" },
          city: { required: "Please enter your city" },
          address: { required: "Please enter your street and house number" },
          phone: {
            required: "Please enter your phone number",
            invalid: "Please enter a valid phone number",
          },
          totalPositive: "The total amount must be greater than 0. ",
        },
        messages: {
          paymentConfigLoading:
            "Payment configuration is loading. Please wait a moment and try again.",
        },
        errors: {
          paymentError:
            "Payment error: {{error}}. Please try again or contact support.",
        },
        login: {
          returning: "Returning customer?",
          clickToLogin: "Click here to login",
          intro1:
            "If you have shopped with us before, please enter your details below.",
          intro2:
            "If you are a new customer, please go to the Billing section.",
          password: "Password",
          loginBtn: "Login",
          remember: "Remember me",
          forgot: "Forgot password?",
          signOut: "sign out",
          errorUnknownEmail:
            "Unknown email address. Check again or try your username.",
          loggedInAs: "You are logged in as {{email}}",
        },
        register: {
          clickToRegister: "Click here to register",
          intro: "Create an account to checkout faster and track your orders.",
          username: "Username",
          password: "Password",
          roleType: "Role type",
          roleSelect: "Select a role",
          roles: {
            customer: "Customer",
            researcher: "Researcher",
          },
          registerBtn: "Register",
          success: "Registration successful. You can now log in.",
          errors: {
            emailRequired: "Please enter your email address",
            emailInvalid: "Please enter a valid email address",
            passwordRequired: "Please enter a password",
            roleRequired: "Please select a role",
          },
          hintOneOf: "Provide at least one: Username or Email",
        },
        agreements: {
          research: "I confirm that these products are intended for laboratory research and not for use in humans or animals.",
          nonPrivate: "I confirm that I am purchasing these products as a researcher, laboratory worker, or student under supervision and not as a private consumer.",
          notMedicine: "I understand that these substances are not approved medicines and are not intended to diagnose, treat, cure, or prevent any disease.",
          terms: "I agree with the terms and conditions",
          offers: "Sign me up for exclusive offers",
          error: "Please accept all required terms and conditions."
        },
        payment: {
          title: "Payment",
          subtitle: "All transactions are secure and encrypted.",
          klarna: "Klarna",
          creditCard: "Pay by Card",
          payNow: "Pay now",
          secure: "Secure and encrypted"
        }
      },
      success: {
        box: {
          thankYou: "Thank you for your order.",
          difference: "Your order has been received successfully.",
          confirm:
            "You will receive an order confirmation via {{channels}} shortly.",
          channels: "email ({{email}}) or SMS ({{phone}})",
        },
        share: {
          progress: "Share progress",
          sharedCount: "Shared {{count}} times",
          inviteText:
            "Check out high‑quality peptides at Puritybase — categories include Fat burning, Muscle building, Serums, Hormonal support, Recovery, Cosmetic and Supplies.",
          return: {
            msg3: "Thanks for sharing! Your support helps us reach more customers.",
            msg7: "Thanks for spreading the word! Your support means a lot to us.",
          },
        },
      },
      account: {
        title: "My account",
        common: {
          loading: "Please wait…",
        },
        login: {
          title: "Login",
          email: "Email address or username",
          password: "Password",
          remember: "Remember me",
          forgot: "Forgot your password?",
          btn: "LOG IN",
          loggedInAs: "You are logged in as {{email}}",
          signOut: "Sign out",
          signOutUpper: "SIGN OUT",
        },
        register: {
          title: "Register",
          email: "Email address",
          password: "Password",
          hint: "A link to set a new password will be sent to your email address.",
          btn: "REGISTER",
          success: "Registration successful! Redirecting…",
        },
        errors: {
          emailRequired: "Please enter your email address or username",
          passwordRequired: "Please enter your password",
          unknownEmail:
            "Unknown email address. Check again or try your username.",
          loginFailed: "Login failed. Please check your credentials.",
          registerFailed: "Registration failed. Please try again.",
        },
      },
      cart: {
        title: "Shopping cart",
        aria: {
          items: "Items",
          remove: "Remove",
        },
        empty: "Your cart is empty.",
        table: {
          product: "Product",
          price: "Price",
          qty: "Number",
          subtotal: "Subtotal",
        },
        summary: {
          title: "Total:",
          subtotal: "Subtotal",
          shipping: "Shipping",
          note: "The shipping options are updated at checkout.",
          total: "Total",
        },
        checkoutBtn: "PROCEED TO CHECKOUT",
        continueShopping: "Continue shopping",
      },
    },
  },
  // 荷兰：荷兰语
  nl: {
    translation: {
      header: {
        about: "Over ons",
        shop: "Winkel",
        lab: "Labresultaten",
        calculator: "Calculator",
        help: "Helpcentrum",
        cartAria: "Winkelwagen",
        accountAria: "Account",
        searchAria: "Zoeken",
        cartTitle: "Uw Winkelwagen",
        searchPlaceholder: "Blijf typen om te zoeken...",
      },
      footer: {
        information: "Informatie",
        bestSellers: "Bestverkopende producten",
        cooperation: "Samenwerking",
        ourSocials: "Onze socials",
        links: {
          calculator: "Peptide Rekenmachine",
          help: "Helpcentrum",
          terms: "Algemene Voorwaarden",
          refund: "Retour- en restitutiebeleid",
          privacy: "Privacybeleid",
          contact: "Contact",
          bulk: "Bulk inkoop",
          partner: "Partner worden",
          shipping: "Verzending",
        },
        langEnglish: "English",
        langDutch: "Nederlands",
        langGerman: "Duits",
        langFrench: "Frans",
        promoFreeShip: "Gratis verzending bij bestellingen boven €250 in de EU",
        entryGate: {
          title: "Kies uw instellingen",
          subtitle:
            "Onze producten zijn uitsluitend voor onderzoeksdoeleinden. Volg de land-specifieke wettelijke richtlijnen.",
          deliveryCountry: "Land van levering",
          language: "Taal",
          searchCountry: "Zoek land...",
          languagePlaceholder: "Kies een taal...",
          ageQuestion: "Bent u 18+ of ouder?",
          ageYes: "Ja, ik ben 18+",
          ageNo: "Nee",
          researchLabel:
            "Ik bevestig dat deze producten exclusief voor onderzoeksdoeleinden zullen worden gebruikt.",
          continue: "Doorgaan",
          cookiePrefix:
            "Door verder te gaan accepteer je het gebruik van cookies. ",
          privacyPolicy: "Privacybeleid",
          accessDeniedTitle: "Toegang geweigerd",
          accessDeniedBody:
            "Je moet 18 jaar of ouder zijn om deze website te bezoeken.",
          countries: {
            NL: "Nederland",
            BE: "België",
            DE: "Duitsland",
            FR: "Frankrijk",
            GB: "Verenigd Koninkrijk",
          },
        },
      },
      main: {
        hero: {
          title_white: "Waar kwaliteit heerst.",
          title_yellow: "Welkom bij Puritybase",
          cta: "Bekijk Peptiden",
          telegram_title: "Join onze Telegram",
          telegram_text: "voor exclusieve deals",
        },
        marquee: [
          "99% Zuiverheid",
          "Nederlandse kwaliteit",
          "Alleen voor onderzoeksdoeleinden",
        ],
        categoriesTitleLight: "Alle",
        categoriesTitleAccent: "Categorieën",
        categories: {
          fat_burning: "Vetverbranding",
          muscle_building: "Spieropbouw",
          serums: "Serums",
          mental_focus: "Mentale focus",
          hormonal_support: "Hormonale Ondersteuning",
          recovery: "Herstel",
          cosmetic: "Cosmetisch",
          supplies: "Benodigdheden",
        },
        productsTitleLight: "Populaire Peptiden in onze",
        productsTitleAccent: "Onderzoekscatalogus",
        productsText:
          "Alle verbindingen zijn batch-getest en worden discreet verzonden",
        viewAll: "Bekijk alles peptides",
        priceFrom: "Vanaf {{price}}",
        buttons: {
          addToCart: "TOEVOEGEN AAN WINKELWAGEN",
          selectOptions: "OPTIES SELECTEREN",
          view: "BEKIJK",
          badgeFreeBox: "• GRATIS PEPTIDE OPBERGDOOSJE",
        },
        aria: {
          previous: "Vorige",
          next: "Volgende",
          goSlide: "Ga naar slide {{n}}",
          goPage: "Ga naar pagina {{n}}",
          hero: "Hero",
          categories: "Categorieën",
          newPeptides: "Nieuwe Peptiden",
          about: "Over Puritybase",
          reasons: "Waarom kiezen voor Puritybase",
          telegram: "Join onze Telegram",
        },
        empty: "Geen producten gevonden.",
        about: {
          titleLight: "Over",
          titleAccent: "Puritybase",
          p1: "Bij Puritybase zetten wij ons in om onderzoekers hoogwaardige, farmaceutisch gegradeerde peptiden te bieden die voldoen aan de strengste normen voor zuiverheid en betrouwbaarheid. Onze missie is het bevorderen van wetenschappelijke vooruitgang door producten aan te bieden die nauwkeurige, consistente en betrouwbare resultaten mogelijk maken.",
          p2: "Elk peptide in ons assortiment wordt onafhankelijk getest en wordt geleverd met een Certificaat van Analyse (COA) om transparantie en vertrouwen te waarborgen. Wij zijn van mening dat onderzoekers toegang verdienen tot producten die niet alleen effectief zijn, maar ook veilig, consistent en zorgvuldig geleverd worden.",
        },
        reasonsTitleAccent: "Waarom Onderzoekers Kiezen voor Puritybase",
        reasonsText: [
          "Wij leveren Europees vervaardigde peptiden met ≥99% geverifieerde zuiverheid. Elke batch wordt onafhankelijk getest en wordt geleverd met een analysecertificaat.",
          "Word lid van onze Telegram-community voor exclusieve deals, onderzoeksupdates en directe ondersteuning van ons team.",
        ],
        reasons: [
          {
            title: "Lab Getest",
            desc: "Alle producten getest op zuiverheid en kwaliteit",
          },
          {
            title: "Dezelfde Dag Verzending",
            desc: "Snelle levering door heel Europa",
          },
          {
            title: "Gebruiksbegeleiding",
            desc: "Deskundig advies over productgebruik",
          },
          {
            title: "Klantenservice",
            desc: "Toegewijde ondersteuning voor al uw vragen",
          },
        ],
        telegram: {
          title: "Ontvang exclusieve kortingen op Telegram",
          text: "Word lid van ons Telegram-kanaal en ontvang als eerste exclusieve kortingen, tijdelijke aanbiedingen en insider-updates die je nergens anders vindt.",
          btn: "Inschrijven",
        },
      },
      aboutPage: {
        hero: {
          aria: "Over Puritybase",
          breadcrumbAria: "Broodkruimelnavigatie",
          breadcrumb: "Home",
          titlePrefix: "Over",
          titleBrand: "Puritybase",
          text: "At Puritybase, we are committed to providing researchers with high-quality pharmaceutical-grade peptides that meet the strictest standards for purity and reliability. Our mission is to support scientific advancement by offering products that enable accurate, consistent, and reliable results.",
        },
        pledge: {
          aria: "Onze Belofte",
          title: "Onze Belofte",
          item1: "Farmaceutische kwaliteit onderzoekspeptiden",
          item2: "Veilige en discrete levering door heel Europa",
          item3: "Geverifieerde zuiverheid en laboratoriumgeteste batches",
          item4: "Toegewijde service om uw onderzoek te ondersteunen",
        },
        why: {
          aria: "Waarom Kiezen voor Puritybase",
          title: "Waarom Kiezen voor Puritybase",
          text: "Wij leveren farmaceutische peptiden, onafhankelijk getest en voorzien van een Certificate of Analysis (COA). Met snelle en discrete wereldwijde verzending, veilige betalingen en professionele verpakking garanderen wij kwaliteit en vertrouwen bij elke bestelling. Ons team is toegewijd aan naleving, betrouwbaarheid en toegewijde klantenservice.",
          card1Title: "Wetenschappelijke Integriteit",
          card1Desc:
            "Elk peptide wordt HPLC-getest op ≥99% zuiverheid, voor betrouwbare en reproduceerbare onderzoeksresultaten.",
          card2Title: "Vertrouwelijk & Conform Wetgeving",
          card2Desc:
            "Uitsluitend voor onderzoeksdoeleinden. Veilige, discrete verpakking met volledige naleving van de geldende regelgeving.",
          card3Title: "Snelle Levering",
          card3Desc: "Ontvang een trackingcode binnen 24 uur na uw bestelling.",
        },
      },
      shop: {
        title: "Shop",
        heroTitle: "Alle Producten",
        heroSubtitle:
          "Bekijk onze complete collectie van hoogwaardige onderzoekspeptiden.",
        breadcrumb: "Home",
        breadcrumbAria: "Broodkruimelnavigatie",
        categoriesAria: "Productcategorieën",
        searchPlaceholder: "Zoek producten...",
        sortBy: "Sorteer op:",
        sortNewest: "Nieuwste",
        sortPriceAsc: "Prijs: laag naar hoog",
        sortPriceDesc: "Prijs: hoog naar laag",
        viewBtn: "BEKIJK",
        saleBadge: "Sale",
        promoBanner: "+ GRATIS PEPTIDE OPBERGDOOSJE",
        emptyTitle: "Geen producten gevonden",
        emptyDesc: "Probeer een andere categorie of zoekterm.",
        clearFilters: "Filters wissen",
        filtersTitle: "Filters",
        toggleFiltersAria: "Filters in-/uitklappen",
        productsAria: "Producten",
        selectOptions: "OPTIES SELECTEREN",
        categories: {
          all: "Alle",
          anti_aging: "Anti Aging",
          bundles: "Bundels",
          pens: "Pennen",
          serums: "Serums",
          fat_burning: "Vetverbranding",
          muscle_building: "Spieropbouw",
          recovery: "Herstel",
          cosmetic: "Cosmetisch",
          hormonal_support: "Hormonale Ondersteuning",
          mental_focus: "Mentale focus",
          supplies: "Benodigdheden",
        },
      },
      lab: {
        title: "Testresultaten",
        breadcrumb: "Home",
        breadcrumbAria: "Broodkruimelnavigatie",
        heroTitle: "Labresultaten",
        heroSubtitle:
          "Onafhankelijke testresultaten van derden voor al onze peptiden",
        aria: {
          testCategories: "Test categorieën",
          reports: "Rapporten",
          resultsTable: "Resultatentabel",
          moreTestCategories: "Meer test categorieën",
        },
        table: {
          type: "Testtype",
          result: "Resultaat",
        },
        tabs: {
          nad_500: "NAD+ 500",
          tirzepatide_30mg: "Tirzepatide 30mg",
          tirzepatide_10mg: "Tirzepatide 10mg",
          retatrutide_30mg: "Retatrutide 30mg",
          retatrutide: "Retatrutide",
          tirzepatide: "Tirzepatide",
          semaglutide: "Semaglutide",
          ghk_cu: "GHK-Cu",
          glow70: "GLOW70",
          klow80: "KLOW80",
          tb_500: "TB-500",
          melanotan_ii: "Melanotan-II",
          igf1_lr3: "IGF-1 LR3",
          cjc_no_dac: "CJC 1295 zonder DAC",
          ipamorelin: "Ipamorelin",
          selank: "Selank",
          semax: "Semax",
        },
        labels: {
          contentMeasured: "Inhoud (gemeten)",
          amountMeasured: "Hoeveelheid (gemeten)",
          purityHPLC: "Zuiverheid (HPLC)",
          purity: "Zuiverheid",
          heavyMetals: "Zware metalen",
          endotoxins: "Endotoxines",
          laboratory: "Laboratorium",
          taskNumber: "Task number",
          verificationCode: "Verificatiecode",
          analysisDate: "Analyse datum",
          verification: "Verificatie",
          peptide: "Peptide",
        },
        values: {
          testedWithinSpecs: "Getest - binnen specificaties",
          underAnalysis: "In analyse / volgt binnenkort",
          notTested: "Niet getest",
          verifyTestReport: "Verifieer testrapport",
          viewVerifyReport: "Bekijk en verifieer het testrapport",
        },
      },
      calculator: {
        title: "Peptide Calculator",
        aria: {
          section: "Rekenmachine",
        },
        labels: {
          syringeVolume: "Wat is het totale volume van uw spuit?",
          vialMg: "Hoeveel mg zit er in de vial?",
          waterMl: "Hoeveel bacteriostatisch water voegt u toe?",
          doseMg: "Hoeveel mg wil je doseren?",
        },
        buttons: {
          other: "Anders",
        },
        alt: {
          vial: "vial",
          water: "bacteriostatisch water",
          syringe: "{{v}} ml spuit",
        },
        result: {
          prefix: "Om een dosis te hebben van",
          suffix: "trek de spuit naar",
        },
      },
      help: {
        title: "Help Center",
        intro1: "Welkom bij het Puritybase Help Center.",
        intro2:
          "Hier vind je antwoorden op de meest gestelde vragen over bestellen, verzending, retouren en onze producten.",
        sections: [
          {
            key: "pay", 
            title: "🛒 Bestellen & Betalen",
            faqs: [
              {
                q: "Welke betaalmethoden bieden jullie aan?",
                a: [
                  "Je kunt veilig en eenvoudig betalen met de meest gebruikte Europese betaalopties.",
                  "Alle betalingen verlopen via een beveiligde SSL-verbinding en worden direct verwerkt.",
                ],
              },
              {
                q: "Wordt mijn betaling direct bevestigd?",
                a: [
                  "Ja. Zodra de betaling is voltooid, ontvang je automatisch een <strong>orderbevestiging per e‑mail</strong>.",
                  "Heb je binnen enkele minuten geen e-mail ontvangen? Controleer je spamfolder of neem contact met ons op.",
                ],
              },
              {
                q: "Hoe wordt mijn bestelling verpakt?",
                a: [
                  "Alle bestellingen worden verzonden in <strong>discrete, neutrale verpakkingen</strong> zonder zichtbare productnamen of logo's aan de buitenkant.",
                  "Binnenin zijn je producten professioneel verpakt om te zorgen dat ze in perfecte staat aankomen."
                ],
              },
            ],
          },
          {
            key: "ship", 
            title: "🚚 Verzending",
            faqs: [
              {
                q: "Naar welke landen verzenden jullie?",
                a: [
                  "We verzenden <strong>vanuit Nederland</strong> naar alle landen binnen de Europese Unie.",
                  "Verwachte levertijden:",
                  "• <strong>Nederland & België:</strong> 1-2 werkdagen",
                  "• <strong>Duitsland, Frankrijk, Luxemburg, Oostenrijk:</strong> 2-4 werkdagen",
                  "• <strong>Spanje, Italië, Portugal:</strong> 3-6 werkdagen",
                  "• <strong>Scandinavië</strong> (Zweden, Denemarken, Finland, Noorwegen): 4-7 werkdagen"
                ],
              },

              {
                q: "Wat zijn de verzendkosten?",
                a: [
                  "De verzendkosten worden automatisch berekend bij het afrekenen:",
                  "• <strong>Nederland:</strong> €4.95",
                  "• <strong>België:</strong> €9.95",
                  "• <strong>Duitsland:</strong> €9.95",
                  "• <strong>Frankrijk:</strong> €9.95",
                  "<br />",
                  "• <strong>Overige Europese landen:</strong> €14.95",
                  "<br />",
                  "<strong>Bestellingen van €250 of meer worden GRATIS verzonden binnen de EU!</strong>"
                ],
              },
              {
                q: "Krijg ik een track & trace‑link?",
                a: [
                  "Ja! Zodra je bestelling is verzonden ontvang je automatisch een e‑mail met de <strong>track & trace‑link</strong> zodat je je pakket in realtime kunt volgen.",
                ],
              },
              {
                q: "Wat gebeurt er bij vertraging of verlies?",
                a: [
                  "Als je bestelling niet binnen de verwachte levertijd is aangekomen, neem dan contact met ons op binnen <strong>10 werkdagen</strong> na het plaatsen van je bestelling.",
                  "<br />",
                  "We starten direct een onderzoek bij de vervoerder en zorgen voor een <strong>volledige terugbetaling of gratis nieuwe zending</strong>."
                ],
              },
            ],
          },
          {
            key: "return", 
            title: "↩️ Retouren & Terugbetalingen",
            faqs: [
              {
                q: "Accepteren jullie retourzendingen?",
                a: [
                  "Nee. Wij accepteren geen retourzendingen. Alle verkopen zijn definitief. Controleer je bestelling zorgvuldig voordat je je aankoop voltooit.",
                ],
              },
              {
                q: "Kan ik een terugbetaling krijgen?",
                a: [
                  "We geven geen terugbetalingen voor het veranderen van gedachten of ongewenste items. Als je bestelling beschadigd of onjuist is aangekomen, neem dan binnen 48 uur na levering contact met ons op met foto's en je bestelnummer.",
                ],
              },
              {
                q: "Kan ik een product ruilen?",
                a: [
                  "Wij bieden geen productruilingen aan."
                ],
              },
            ],
          },
          {
            key: "contact",
            icon: "/main/h4.svg",
            title: "💬 Contact & Support",
            faqs: [
              {
                q: "Hoe kan ik contact opnemen?",
                a: [
                  "We bieden meerdere manieren om ons te bereiken:",
                  "<br />",
                  "📧 <strong>E-mail:</strong> info@example.com",
                  "→ Reactie binnen 2-3 werkdagen",
                  "<br />",
                  "📝 <strong>Contactformulier:</strong> Op onze website",
                  "→ Reactie binnen 2-3 werkdagen",
                  "<br />",
                  "💬 <strong>Telegram:</strong>",
                  "→ Reactie binnen 2-3 uur (snelste!)",
                  "<br />",
                  "Voor dringende vragen is Telegram je beste optie!"
                ],
              },
              {
                q: "Wat zijn jullie openingstijden?",
                a: [
                  "Onze klantenservice is bereikbaar:",
                  "<br />",
                  "<strong>Maandag - Vrijdag:</strong> 9:00 - 17:00 CET",
                  "<br />",
                  "Telegram support is ruimer beschikbaar en reageert doorgaans veel sneller dan e-mail."
                ],
              },
            ],
          },
        ],
      },
      terms: {
        title: "Algemene Voorwaarden",
        breadcrumb: "Home",
        breadcrumbAria: "Broodkruimelnavigatie",
        lastUpdated: "Laatst bijgewerkt: januari 2025",
        intro:
          "Onderstaande bepalingen gelden voor uw gebruik van deze website en elke geplaatste bestelling.",
        sections: [
          {
            title: "1. Algemeen",
            body: "Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, bestellingen en overeenkomsten via onze website.",
          },
          {
            title: "2. Prijzen",
            body: "Alle prijzen zijn in Euro's en inclusief BTW. Prijzen kunnen zonder voorafgaande kennisgeving worden gewijzigd.",
          },
          {
            title: "3. Bestellen",
            body: "Door een bestelling te plaatsen, gaat u akkoord met deze algemene voorwaarden.",
          },
          {
            title: "4. Betaling",
            body: "Betaling dient te geschieden voor verzending. Wij accepteren diverse betaalmethoden waaronder iDEAL, creditcard en PayPal.",
          },
          {
            title: "5. Levering",
            body: "Wij verzenden binnen 1-2 werkdagen. Levertijden zijn afhankelijk van uw locatie.",
          },
        ],
      },
      refunds: {
        breadcrumb: "Home",
        breadcrumbAria: "Broodkruimelnavigatie",
        badgeBrand: "KING'S ACCESS",
        badgePoints: "214 PTS",
        title: "Retour- en terugbetalingsbeleid",
        intro:
          "Bij Puritybase staan kwaliteit, veiligheid en klanttevredenheid voorop. Vanwege de aard van onze producten hanteren wij een strikt maar eerlijk beleid gericht op productveiligheid en snelle oplossing van eventuele problemen.",
        sections: [
          {
            title: "Geen retour op peptiden",
            paragraphs: [
              "Vanwege de aard van peptiden en laboratoriumchemicaliën zijn retouren niet mogelijk. Na verzending kan het product niet opnieuw worden verkocht of gecontroleerd op steriele omstandigheden.",
              "Dit beleid is noodzakelijk om de veiligheid van onze klanten en de integriteit en zuiverheid van onze producten te waarborgen. Door een bestelling te plaatsen, gaat u akkoord met dit beleid.",
            ],
          },
          {
            title: "Beschadigde levering of gebroken flacon",
            paragraphs: [
              "Als uw bestelling beschadigd is aangekomen of een gebroken flacon bevat, neem dan binnen 48 uur na levering contact met ons op per e-mail of <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> en voeg duidelijke foto's bij.",
              "<strong>Vereisten:</strong>",
            ],
            list: [
              "duidelijke foto's van het product",
              "duidelijke foto's van de originele verpakking",
              "duidelijke foto's van de zichtbare schade",
            ],
            paragraphsTail: [
              "In deze gevallen sturen wij gratis een vervangende zending. Dit is onze standaardoplossing om u zo snel mogelijk te helpen.",
            ],
          },
          {
            title: "Terugbetaling (alleen na tweede zending)",
            paragraphs: ["Een terugbetaling is alleen mogelijk als:"],
            list: [
              "er twee zendingen zijn geweest (de originele zending + een gratis vervangende zending), en",
              "er opnieuw een probleem is bij de tweede zending (bijvoorbeeld beschadiging of een gebroken flacon).",
            ],
            paragraphsTail: [
              "In dat uitzonderlijke geval bieden wij een volledige terugbetaling aan.",
              "Met andere woorden, wij sturen altijd eerst een vervangend product; alleen bij herhaald falen wordt een terugbetaling overwogen.",
            ],
          },
          {
            title: "Voorwaarden voor vervanging en eventuele terugbetaling",
            list: [
              "Schade moet binnen 48 uur na levering worden gemeld",
              "Foto's van het beschadigde product en de originele verpakking zijn vereist",
              "Producten moeten ongebruikt en in originele staat zijn",
              "In sommige gevallen kan u worden gevraagd het beschadigde artikel terug te sturen ter verificatie.",
            ],
          },
          {
            title: "Onjuist ingevoerd verzendadres",
            paragraphs: [
              "Controleer uw verzendinformatie altijd zorgvuldig. Als een bestelling niet kan worden bezorgd vanwege een onjuist of onvolledig adres, kunnen wij geen vervanging of terugbetaling garanderen.",
            ],
          },
          {
            title: "Contact",
            paragraphs: [
              "Heeft u vragen of is er een probleem met uw bestelling? Neem contact met ons op via e-mail of <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a>. Wij helpen u graag binnen de kaders van dit beleid.",
            ],
            email: "info@hgppeps.com",
          },
        ],
      },
      privacy: {
        title: "Privacybeleid",
        breadcrumb: "Home",
        breadcrumbAria: "Broodkruimelnavigatie",
        lastUpdated: "Laatst bijgewerkt: januari 2025",
        intro: "Uw privacy is belangrijk voor ons.",
        sections: [
          {
            title: "1. Gegevensverzameling",
            body: "Wij verzamelen informatie die u verstrekt bij het plaatsen van bestellingen, waaronder naam, e-mail en verzendadres.",
          },
          {
            title: "2. Gegevensgebruik",
            body: "Wij gebruiken uw gegevens om bestellingen te verwerken, updates te versturen en onze diensten te verbeteren.",
          },
          {
            title: "3. Gegevensbescherming",
            body: "Wij implementeren beveiligingsmaatregelen om uw persoonlijke informatie te beschermen.",
          },
          {
            title: "4. Cookies",
            body: "Wij gebruiken cookies om uw browse-ervaring te verbeteren. U kunt cookievoorkeuren beheren in uw browser.",
          },
          {
            title: "5. Uw rechten",
            body: "U hebt het recht om uw persoonlijke gegevens in te zien, te corrigeren of te verwijderen. Neem contact met ons op voor verzoeken.",
          },
        ],
      },
      shippingPage: {
        breadcrumb: "Home",
        breadcrumbAria: "Broodkruimelnavigatie",
        badgeBrand: "KING'S ACCESS",
        badgePoints: "214 PTS",
        title: "Verzendingsinformatie",
        subtitle: "Snelle en betrouwbare levering door heel Europa",
        promoAria: "Gratis verzending",
        promoLead: "Gratis verzending: ",
        promoDetail: "Op alle bestellingen boven €250 binnen de EU",
        colDestination: "Bestemming",
        colStandard: "Standaard",
        colExpress: "Express",
        rows: [
          {
            destination: "Nederland",
            standardDays: "1-2 dagen",
            standardPrice: "€4,95",
            express: "",
          },
          {
            destination: "België",
            standardDays: "2-3 dagen",
            standardPrice: "€9,95",
            express: "",
          },
          {
            destination: "Duitsland",
            standardDays: "2-4 dagen",
            standardPrice: "€14,95",
            express: "",
          },
          {
            destination: "Overige EU",
            standardDays: "3-7 dagen",
            standardPrice: "€14,95",
            express: "",
          },
        ],
        processTitle: "Verzendproces",
        processBody:
          "Bestellingen geplaatst voor 14:00 op werkdagen worden dezelfde dag verzonden.",
        trackingTitle: "Tracking",
        trackingBody:
          "U ontvangt een trackinglink per e-mail zodra uw bestelling is verzonden.",
      },
      contact: {
        title: "Hulp Nodig? Wij Staan Voor Je Klaar",
        intro:
          "Van productvragen tot hulp bij bestellingen of informatie over compliance – ons toegewijde team staat klaar om je in elke stap te begeleiden.",
        helpBtn: "HELP CENTER",
        cards: {
          hoursTitle: "Klantenservice Openingstijden",
          hoursText:
            "Maandag – Vrijdag: 09:00 – 17:00 (Uitzondering: feestdagen)",
          contactTitle: "Contact & Support",
          contactIntro:
            "Onze klantenservice is ALLEEN beschikbaar op <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> en <a class='privacy__link' href='" + telegram + "' target='_blank' rel='noopener noreferrer'>Telegram</a>!",
          whatsapp: "WhatsApp(1–2 uur)",
          telegram: "Telegram(1–2 uur)",
        },
      },
      bulk: {
        breadcrumbHome: "Home",
        title: "Groothandel",
        intro:
          "Op zoek naar grotere aantallen voor onderzoeksdoeleinden? Wij leveren grotere volumes voor labs, resellers en onderzoeksprojecten. Afhalen is ook mogelijk op afspraak.",
        form: {
          title: "Offerte aanvragen",
          nameLabel: "Volledige naam",
          emailLabel: "E-mailadres",
          requestLabel: "Uw aanvraag",
          namePlaceholder: "Uw naam",
          emailPlaceholder: "uw@email.nl",
          requestPlaceholder:
            "Vermeld a.u.b.: product(en), gewenste hoeveelheid (mg / aantal vials), en voorkeur (verzending of afhalen)",
          submit: "Aanvraag versturen",
          submitting: "Verzenden…",
          submitSuccess: "Bedankt — uw aanvraag is verstuurd.",
          submitError:
            "Er ging iets mis. Probeer het over een ogenblik opnieuw.",
          requiredStar: "*",
        },
        sections: [
          {
            title: "Voor wie is groothandel geschikt?",
            list: [
              "Laboratoria & onderzoeksinstellingen",
              "Partners / resellers (op aanvraag)",
              "Grotere onderzoeksprojecten met terugkerende aankopen",
            ],
          },
          {
            title: "Wat kun je van ons verwachten",
            list: [
              "Staffelkorting bij grotere afnames",
              "Consistente batchkwaliteit (waar beschikbaar met labresultaten/COA)",
              "Discreet verpakt of persoonlijk ophalen op afspraak",
              "Snelle communicatie en duidelijke afspraken",
            ],
          },
          {
            title: "Hoe werkt het?",
            ordered: [
              "Stuur je aanvraag met product(en), hoeveelheid en voorkeur (verzending of afhalen)",
              "Wij controleren voorraad, batches en opties",
              "Je ontvangt een scherpe offerte + levertijd",
              "Na akkoord regelen wij verzending of afhaling",
            ],
          },
          {
            title: "Algemene staffelkorting",
            boxed: true,
            paragraphs: ["<strong>Minimale bestelhoeveelheid:</strong>"],
            list: [
              "10 stuks per product: <strong>30% korting</strong>",
              "20 stuks per product: <strong>35% korting</strong>",
              "30 stuks per product: <strong>40% korting</strong>",
            ],
            tail: ["Een mix van meerdere producten is altijd bespreekbaar!"],
          },
        ],
      },
      partner: {
        breadcrumbHome: "Home",
        title: "Word Partner",
        intro:
          "Werk samen met Puritybase en verdien geld met hoogwaardige onderzoeksproducten. Ons partnerprogramma is ontworpen voor creators, communities en professionals die transparant en professioneel willen samenwerken.",
        form: {
          title: "Aanmelden als partner",
          nameLabel: "Volledige naam",
          emailLabel: "E-mailadres",
          platformLabel: "Platform / Website",
          messageLabel: "Bericht",
          namePlaceholder: "Uw naam",
          emailPlaceholder: "uw@email.nl",
          platformPlaceholder: "Uw website of social media kanaal",
          messagePlaceholder: "Vertel ons over uw platform en doelgroep",
          submit: "Aanmelding versturen",
          submitting: "Verzenden…",
          submitSuccess: "Bedankt — uw aanmelding is verstuurd.",
          submitError:
            "Er ging iets mis. Probeer het over een ogenblik opnieuw.",
          requiredStar: "*",
        },
        sections: [
          {
            title: "Waarom partner worden?",
            list: [
              "Aantrekkelijke commissies per succesvolle verwijzing",
              "Realtime inzicht in kliks, conversies en omzet",
              "Persoonlijke affiliate links en (optioneel) kortingscodes",
              "Snelle en betrouwbare uitbetalingen",
              "Samenwerken met een snelgroeiend premium merk",
            ],
          },
          {
            title: "Voor wie is dit programma?",
            listLead: "Ons affiliate programma is geschikt voor:",
            list: [
              "Educatieve content creators",
              "Fitness, biohacking & onderzoekscommunities",
              "Coaches en informatieve platformen",
              "Websites en social media kanalen met een relevante doelgroep",
            ],
          },
          {
            title: "Hoe werkt het?",
            ordered: [
              "Registreer via ons partnerportaal",
              "Ontvang je persoonlijke affiliate link",
              "Deel Puritybase op jouw platform",
              "Verdien commissie op elke kwalificerende bestelling",
            ],
          },
          {
            title: "Transparent & Professional",
            boxed: true,
            paragraphs: [
              "Wij hechten veel waarde aan correcte communicatie, duidelijke disclaimers, naleving van wet- en regelgeving en langdurige samenwerkingen. Samenwerkingen zijn uitsluitend voor informatieve en promotionele doeleinden. Onze producten zijn uitsluitend voor onderzoeksdoeleinden (in vitro).",
            ],
          },
        ],
      },
      pd: {
        crumbs: { home: "Home", products: "Producten", category: "Herstel" },
        labels: {
          concentration: "Concentratie (mg)",
          water: "bacteriostatisch water",
          waterStd: "(standaard bijgeleverd)",
          needles: "Insulinenaalden",
          needlesNone: "Geen",
          needle05: "10x 0.5ml insulinenald",
          needle1: "10x 1ml insulinenald",
          wipes: "Alcoholdoekjes",
          yes: "Ja",
          no: "Nee",
          clear: "Wissen",
        },
        purchase: {
          quantity: "Aantal",
          price: "Prijs",
          decreaseQty: "Minder",
          increaseQty: "Meer",
          inStock: "Op voorraad",
          addToCart: "TOEVOEGEN AAN WINKELWAGEN",
        },
        shipping: {
          b1: "Levering binnen 1 werkdagen",
          b2: "Levering naar afhaalpunt beschikbaar",
          b3: "Discrete verzending",
          securePayments: "Veilige betalingen",
        },
        cutoff: {
          headline: "Bestel voor {{time}} voor verzending op dezelfde dag",
          within: "Bestel binnen",
          hours: "uur",
          minutes: "minuten",
          ordered: "Besteld",
          shipped: "Verzonden",
          delivered: "Bezorgd",
          today: "Vandaag",
          nextDay: "Morgen",
          countryAria: "Land of regio voor verzending",
          countryUk: "Verenigd Koninkrijk",
          countryNl: "Nederland",
        },
        tabs: {
          desc: "BESCHRIJVING",
          ship: "VERZENDING & LEVERING",
          lab: "LABRESULTATEN",
          use: "GEBRUIK & DISCLAIMER",
        },
        desc: {
          p1: "<strong>GHK‑Cu</strong> is een koperbindende tripeptide bestaande uit <strong>3 aminozuren</strong> (glycyl‑L‑histidyl‑L‑lysine) gekoppeld aan een koperion (Cu<sup>2+</sup>). Binnen onderzoekscontext staat deze molecule bekend om haar rol in celcommunicatie en regeneratief onderzoek.",
          p2: "GHK‑Cu wordt in wetenschappelijke settings onderzocht vanwege interacties met processen rond <strong>weefselremodellering</strong>, <strong>collagensynthese</strong>, <strong>celherstel</strong> en oxidatieve stressregulatie.",
          relev: "Onderzoeksrelevantie",
          list: [
            "Onderzocht binnen modellen rond huid‑ en bindweefselregeneratie.",
            "Relevant binnen studies naar collageen‑ en extracellulaire matrixprocessen.",
            "Bestudeerd in relatie tot oxidatieve stress en celcommunicatie.",
            "Toegepast binnen experimentele opstellingen rond regeneratieve mechanismen.",
          ],
          specTitle: "Belangrijke specificaties",
          specHeadKey: "Kenmerk",
          specHeadVal: "Waarde / uitleg",
          specRows: [
            ["Type peptide", "Koperbindende tripeptide (GHK‑Cu)"],
            ["Aantal aminozuren", "3"],
            ["Beschikbare varianten", "50mg, 100mg"],
          ],
        },
        shipTab: {
          ukRegion: "<strong>Verenigd Koninkrijk:</strong> {{nextDay}} · {{price}}",
          nlBeRegion: "<strong>Nederland &amp; België:</strong> 1–2 werkdagen · {{price}}",
          restEurope: "<strong>Rest van Europa:</strong> 3–7 werkdagen · {{price}}",
          originNote: "Verzending vanuit Nederland · Discreet verpakt · Track &amp; trace inbegrepen",
          freeShippingUk: "<strong>Gratis verzending</strong> bij bestellingen boven <strong>{{threshold}}</strong>",
          freeShippingEu: "<strong>Gratis verzending</strong> bij bestellingen boven <strong>{{threshold}}</strong>",
        },
        labTab: {
          p1: "Onze producten zijn onafhankelijk getest door een extern laboratorium. De bijbehorende testrapporten, inclusief verificatiecodes, zijn openbaar beschikbaar.",
          link: "Bekijk onze labresultaten",
        },
        useTab: {
          list: [
            "Uitsluitend bedoeld voor <strong>onderzoeksdoeleinden</strong>.",
            "Niet voor menselijk gebruik, diagnose of behandeling.",
            "Alleen te gebruiken door gekwalificeerd personeel in een gecontroleerde onderzoeksomgeving.",
            "Door dit product te kopen bevestig je kennis te hebben genomen van deze voorwaarden en de juiste onderzoekspraktijken te volgen.",
          ],
        },
        related: "Gerelateerde producten",
      },
      drawer: {
        ariaCart: "Winkelwagen",
        close: "Sluiten",
        remove: "Verwijderen",
        subtotal: "Subtotaal:",
        viewCart: "Winkelwagen bekijken",
        checkout: "AFREKENEN",
        freeShipping: "Je komt in aanmerking voor gratis verzending!",
        freeShippingMore: "Nog {{amount}} voor gratis verzending",
        securePayments: "Veilig betalen",
        qtyDecrease: "Aantal verlagen",
        qtyIncrease: "Aantal verhogen",
      },
      checkout: {
        title: "Afrekenen",
        aria: {
          billing: "Factureringsgegevens",
          order: "Jouw bestelling",
          contact: "Contact",
          delivery: "Bezorging",
        },
        labels: {
          firstName: "Voornaam *",
          lastName: "Achternaam *",
          email: "E‑mailadres *",
          country: "Land/regio *",
          phoneOptional: "Telefoon (optioneel)",
          postalCode: "Postcode *",
          province: "Provincie *",
          city: "Plaats *",
          street: "Straat *",
        },
        order: {
          title: "Jouw bestelling",
          product: "Product",
          subtotal: "Subtotaal",
          shipping: "Verzending",
          total: "Totaal",
          qtyLabel: "Aantal",
          shippingMethod: "Verzendmethode",
          carrierLaPoste: "Royal Mail Tracked 24®",
          shippingFree: "Gratis",
        },
        payNow: "Betaal nu",
        validation: {
          email: {
            invalid: "Voer een geldig e‑mailadres in",
            required: "Vul je e‑mailadres in",
          },
          firstName: { required: "Vul je voornaam in" },
          lastName: { required: "Vul je achternaam in" },
          zipCode: {
            required: "Vul je postcode in",
            invalid: "Voer een geldige postcode in",
          },
          state: { required: "Selecteer een provincie" },
          city: { required: "Vul je plaats in" },
          address: { required: "Vul je straat en huisnummer in" },
          phone: {
            required: "Vul je telefoonnummer in",
            invalid: "Voer een geldig telefoonnummer in",
          },
          totalPositive:
            "Het totaalbedrag moet groter zijn dan 0. Voer een bedrag in.",
        },
        messages: {
          paymentConfigLoading:
            "Betaalconfiguratie wordt geladen. Wacht even en probeer het opnieuw.",
        },
        errors: {
          paymentError:
            "Betalingsfout: {{error}}. Probeer het opnieuw of neem contact op met support.",
        },
        login: {
          returning: "Terugkerende klant?",
          clickToLogin: "Klik hier om in te loggen",
          intro1:
            "Als je al eerder bij ons hebt gewinkeld, vul dan hieronder je gegevens in.",
          intro2:
            "Als je een nieuwe klant bent, ga dan naar het gedeelte Facturering.",
          password: "Wachtwoord",
          loginBtn: "Inloggen",
          remember: "Onthoud mij",
          forgot: "Wachtwoord vergeten?",
          signOut: "uitloggen",
          errorUnknownEmail:
            "Onbekend e‑mailadres. Opnieuw controleren of probeer je gebruikersnaam.",
          loggedInAs: "Je bent ingelogd als {{email}}",
        },
        register: {
          clickToRegister: "Klik hier om te registreren",
          intro:
            "Maak een account aan om sneller af te rekenen en bestellingen te volgen.",
          username: "Gebruikersnaam",
          password: "Wachtwoord",
          roleType: "Roltype",
          roleSelect: "Selecteer een rol",
          roles: {
            customer: "Klant",
            researcher: "Onderzoeker",
          },
          registerBtn: "Registreren",
          success: "Registratie geslaagd. Je kunt nu inloggen.",
          errors: {
            emailRequired: "Vul je e‑mailadres in",
            emailInvalid: "Voer een geldig e‑mailadres in",
            passwordRequired: "Vul je wachtwoord in",
            roleRequired: "Selecteer een rol",
          },
          hintOneOf:
            "Vul ten minste één van de twee in: Gebruikersnaam of E‑mailadres",
        },
        agreements: {
          research: "Ik bevestig dat deze producten bestemd zijn voor laboratoriumonderzoek en niet voor gebruik bij mensen of dieren.",
          nonPrivate: "Ik bevestig dat ik deze producten koop als onderzoeker, laboratoriummedewerker of student onder supervisie en niet als particuliere consument.",
          notMedicine: "Ik begrijp dat deze stoffen geen goedgekeurde geneesmiddelen zijn en niet bedoeld zijn om een ziekte te diagnosticeren, behandelen, genezen of voorkomen.",
          terms: "Ik ga akkoord met de algemene voorwaarden",
          offers: "Meld mij aan voor exclusieve aanbiedingen",
          error: "Accepteer a.u.b. alle vereiste algemene voorwaarden."
        },
        payment: {
          title: "Betaling",
          subtitle: "Alle transacties zijn beveiligd en versleuteld.",
          klarna: "Klarna",
          creditCard: "Betalen met kaart",
          payNow: "Nu betalen",
          secure: "Beveiligd en versleuteld"
        }
      },
      success: {
        box: {
          thankYou: "Bedankt voor je bestelling.",
          difference: "Je bestelling is succesvol ontvangen.",
          confirm:
            "Je ontvangt binnenkort een bestelbevestiging via {{channels}}.",
          channels: "e‑mail ({{email}}) of sms ({{phone}})",
        },
        share: {
          progress: "Deelvoortgang",
          sharedCount: "{{count}} keer gedeeld",
          inviteText:
            "Ontdek hoogwaardige peptiden bij Puritybase — categorieën zoals Vetverbranding, Spieropbouw, Serums, Hormonale Ondersteuning, Herstel, Cosmetisch en Benodigdheden.",
          return: {
            msg3: "Dank voor het delen! Je helpt ons meer klanten te bereiken.",
            msg7: "Bedankt voor het delen! Jouw steun betekent veel voor ons.",
          },
        },
      },
      cart: {
        title: "Uw winkelwagen",
        aria: {
          items: "Items",
          remove: "Verwijderen",
        },
        empty: "Je winkelwagen is leeg.",
        table: {
          product: "Producten",
          price: "Subtotaal",
          qty: "Aantal",
          subtotal: "Subtotaal",
        },
        summary: {
          title: "Besteloverzicht",
          subtotal: "Subtotaal",
          shipping: "Verzending",
          note: "De verzendopties worden bij het afrekenen geüpdatet.",
          total: "Totaal",
        },
        checkoutBtn: "DOORGAAN NAAR AFREKENEN",
        continueShopping: "Verder winkelen",
      },
      account: {
        title: "Mijn account",
        common: {
          loading: "Even geduld…",
        },
        login: {
          title: "Inloggen",
          email: "Gebruikersnaam of e-mailadres",
          password: "Wachtwoord",
          remember: "Onthouden",
          forgot: "Je wachtwoord vergeten?",
          btn: "INLOGGEN",
          loggedInAs: "Je bent ingelogd als {{email}}",
          signOut: "Uitloggen",
          signOutUpper: "UITLOGGEN",
        },
        register: {
          title: "Registreren",
          email: "E-mailadres",
          password: "Wachtwoord",
          hint: "Er wordt een link om een nieuw wachtwoord in te stellen naar je e-mailadres verzonden.",
          btn: "REGISTREREN",
          success: "Registratie succesvol! Doorsturen…",
        },
        errors: {
          emailRequired: "Vul je e-mailadres of gebruikersnaam in",
          passwordRequired: "Vul je wachtwoord in",
          unknownEmail:
            "Onbekend e-mailadres. Controleer of probeer je gebruikersnaam.",
          loginFailed: "Inloggen mislukt. Controleer je gegevens.",
          registerFailed: "Registreren mislukt. Probeer het opnieuw.",
        },
      },
    },
  },
  // 德国：德语
  de: {
    translation: {
      header: {
        about: "Über uns",
        shop: "Shop",
        lab: "Laboregebnisse",
        calculator: "Rechner",
        help: "Hilfe-Center",
        cartAria: "Warenkorb",
        accountAria: "Konto",
        searchAria: "Suche",
        cartTitle: "Warenkorb",
        searchPlaceholder: "Weitersuchen...",
      },
      footer: {
        information: "Informationen",
        bestSellers: "Bestseller",
        cooperation: "Kooperation",
        ourSocials: "Unsere Social-Media-Kanäle",
        links: {
          calculator: "Peptid-Rechner",
          help: "Hilfe-Center",
          terms: "Allgemeine Geschäftsbedingungen",
          refund: "Rückgabe- und Erstattungsrichtlinie",
          privacy: "Datenschutz",
          contact: "Kontakt",
          bulk: "Großbestellungen",
          partner: "Partner werden",
          shipping: "Versand",
        },
        langEnglish: "Englisch",
        langDutch: "Niederländisch",
        langGerman: "Deutsch",
        langFrench: "Französisch",
        promoFreeShip: "Kostenloser Versand bei EU-Bestellungen über 250 €",
        entryGate: {
          title: "Einstellungen wählen",
          subtitle:
            "Unsere Produkte sind ausschließlich für Forschungszwecke bestimmt. Bitte beachten Sie die gesetzlichen Vorgaben Ihres Landes.",
          deliveryCountry: "Lieferland",
          language: "Sprache",
          searchCountry: "Länder suchen...",
          languagePlaceholder: "Sprache wählen...",
          ageQuestion: "Sind Sie 18 Jahre oder älter?",
          ageYes: "Ja, ich bin 18+",
          ageNo: "Nein",
          researchLabel:
            "Ich bestätige, dass diese Produkte ausschließlich zu Forschungszwecken verwendet werden.",
          continue: "Weiter",
          cookiePrefix: "Mit dem Fortfahren akzeptieren Sie die Verwendung von Cookies. ",
          privacyPolicy: "Datenschutz",
          accessDeniedTitle: "Zugriff verweigert",
          accessDeniedBody: "Sie müssen mindestens 18 Jahre alt sein, um diese Website zu besuchen.",
          countries: {
            NL: "Niederlande",
            BE: "Belgien",
            DE: "Deutschland",
            FR: "Frankreich",
            GB: "Vereinigtes Königreich",
          },
        },
      },
      main: {
        hero: {
          title_white: "Peptide in Forschungsqualität",
          title_yellow: "Für konstante Ergebnisse",
          cta: "Peptide kaufen",
          telegram_title: "Telegram beitreten",
          telegram_text: "für exklusive Angebote",
        },
        marquee: ["99% REINHEIT", "NIEDERLÄNDISCHE QUALITÄT", "NUR FÜR FORSCHUNGSZWECKE"],
        categoriesTitleLight: "Alle",
        categoriesTitleAccent: "Kategorien",
        categories: {
          fat_burning: "Fettabbau",
          muscle_building: "Muskelaufbau",
          serums: "Seren",
          mental_focus: "Mentale Fokussierung",
          hormonal_support: "Hormonelle Unterstützung",
          recovery: "Erholung",
          cosmetic: "Kosmetik",
          supplies: "Zubehör",
        },
        productsTitleLight: "Beliebte Peptide in unserem",
        productsTitleAccent: "Forschungskatalog",
        productsText: "Alle Verbindungen werden chargenweise getestet und diskret versandt",
        viewAll: "Alle Peptide ansehen",
        priceFrom: "Ab {{price}}",
        buttons: {
          addToCart: "IN DEN WARENKORB",
          selectOptions: "OPTIONEN WÄHLEN",
          view: "ANSICHT",
          badgeFreeBox: "• KOSTENLOSE PEPTID-AUFbewahrUNGSBOX",
        },
        aria: {
          previous: "Zurück",
          next: "Weiter",
          goSlide: "Zur Folie {{n}}",
          goPage: "Zur Seite {{n}}",
          hero: "Hero",
          categories: "Kategorien",
          newPeptides: "Neue Peptide",
          about: "Über Puritybase",
          reasons: "Warum Puritybase wählen",
          telegram: "Telegram beitreten",
        },
        empty: "Keine Produkte gefunden.",
        about: {
          titleLight: "Über",
          titleAccent: "Puritybase",
          p1: "Bei Puritybase sind wir bestrebt, Forschern hochwertige, pharmazeutische Peptide zu liefern, die höchste Reinheits- und Zuverlässigkeitsstandards erfüllen. Unser Ziel ist es, den wissenschaftlichen Fortschritt voranzutreiben, indem wir Produkte liefern, die genaue, konsistente und zuverlässige Ergebnisse ermöglichen.",
          p2: "Jedes Peptid in unserem Katalog wird unabhängig getestet und kommt mit einem Analyse-Zertifikat (COA), um Transparenz und Vertrauen zu gewährleisten. Wir sind überzeugt, dass Forscher Produkte verdienen, die nicht nur wirksam, sondern auch sicher, konsistent und sorgfältig geliefert werden.",
        },
        reasonsTitleAccent: "Warum Forscher Puritybase wählen",
        reasonsText: [
          "Wir liefern europäisch hergestellte Peptide mit ≥99% verifizierter Reinheit. Jede Charge wird unabhängig getestet und kommt mit einem Analyse-Zertifikat.",
          "Treten Sie unserer Telegram-Community bei für exklusive Angebote, Forschungs-Updates und direkten Support von unserem Team.",
        ],
        reasons: [
          {
            title: "Laborgetestet",
            desc: "Alle Produkte auf Reinheit und Qualität getestet",
          },
          {
            title: "Versand am selben Tag",
            desc: "Schnelle Lieferung in ganz Europa",
          },
          {
            title: "Handhabungsberatung",
            desc: "Fachkundige Beratung zur Produkt Handhabung",
          },
          {
            title: "Kundenservice",
            desc: "Dedizierter Support für alle Anfragen",
          },
        ],
        telegram: {
          title: "Exklusive Angebote auf Telegram",
          text: "Treten Sie unserem Telegram-Kanal bei und erhalten Sie als Erster private Rabatte, zeitlich begrenzte Angebote und Insider-Updates, die Sie nirgendwo anders finden.",
          btn: "Beitreten",
        },
      },
      aboutPage: {
        hero: {
          aria: "Über Puritybase",
          breadcrumbAria: "Brotkrumen",
          breadcrumb: "Startseite",
          titlePrefix: "Über",
          titleBrand: "Puritybase",
          text: "Bei Puritybase sind wir bestrebt, Forschern hochwertige pharmazeutische Peptide zu liefern, die strengste Reinheits- und Zuverlässigkeitsstandards erfüllen. Unser Ziel ist es, den wissenschaftlichen Fortschritt zu unterstützen, indem wir Produkte anbieten, die genaue, konsistente und zuverlässige Ergebnisse ermöglichen.",
        },
        pledge: {
          aria: "Unser Versprechen",
          title: "Unser Versprechen",
          item1: "Pharmazeutische Forschungspeptide",
          item2: "Sichere und diskrete Lieferung in ganz Europa",
          item3: "Verifizierte Reinheit und laborgetestete Chargen",
          item4: "Dedizierter Service zur Unterstützung Ihrer Forschung",
        },
        why: {
          aria: "Warum Puritybase wählen",
          title: "Warum Puritybase wählen",
          text: "Wir liefern pharmazeutische Peptide, unabhängig getestet und begleitet von einem Analyse-Zertifikat (COA). Mit schnellem und diskretem weltweiten Versand, sicheren Zahlungen und professioneller Verpackung garantieren wir Qualität und Vertrauen bei jeder Bestellung. Unser Team ist engagiert für Compliance, Zuverlässigkeit und dedizierten Kundenservice.",
          card1Title: "Wissenschaftliche Integrität",
          card1Desc:
            "Jedes Peptid wird HPLC-getestet auf ≥99% Reinheit, um zuverlässige und reproduzierbare Forschungsergebnisse zu gewährleisten.",
          card2Title: "Vertraulich & Konform",
          card2Desc:
            "Nur für Forschungszwecke. Sichere, diskrete Verpackung mit vollständiger behördlicher Konformität.",
          card3Title: "Schnelle Lieferung",
          card3Desc: "Erhalten Sie innerhalb von 24 Stunden nach Ihrer Bestellung einen Tracking-Code.",
        },
      },
      shop: {
        title: "Shop",
        heroTitle: "Alle Produkte kaufen",
        heroSubtitle:
          "Durchsuchen Sie unsere vollständige Sammlung von Premium-Forschungspeptiden.",
        breadcrumb: "Startseite",
        breadcrumbAria: "Brotkrumen",
        categoriesAria: "Produktkategorien",
        searchPlaceholder: "Produkte suchen...",
        sortBy: "Sortieren nach:",
        sortNewest: "Neueste",
        sortPriceAsc: "Preis: Aufsteigend",
        sortPriceDesc: "Preis: Absteigend",
        viewBtn: "ANSICHT",
        saleBadge: "Angebot",
        promoBanner: "+ KOSTENLOSE PEPTID-AUFBEWAHRUNGSBOX",
        emptyTitle: "Keine Produkte gefunden",
        emptyDesc: "Versuchen Sie eine andere Kategorie oder Suche.",
        clearFilters: "Filter löschen",
        filtersTitle: "Filter",
        toggleFiltersAria: "Filter umschalten",
        productsAria: "Produkte",
        selectOptions: "OPTIONEN WÄHLEN",
        categories: {
          all: "Alle",
          anti_aging: "Anti-Aging",
          bundles: "Bundles",
          pens: "Pens",
          serums: "Seren",
          fat_burning: "Fettabbau",
          muscle_building: "Muskelaufbau",
          recovery: "Erholung",
          cosmetic: "Kosmetik",
          hormonal_support: "Hormonelle Unterstützung",
          mental_focus: "Mentale Fokussierung",
          supplies: "Zubehör",
        },
      },
      lab: {
        title: " Testergebnisse",
        breadcrumb: "Startseite",
        breadcrumbAria: "Brotkrumen",
        heroTitle: "Laboregebnisse",
        heroSubtitle:
          "Unabhängige Drittpartei-Testergebnisse für alle unsere Peptide",
        aria: {
          testCategories: "Testkategorien",
          reports: "Berichte",
          resultsTable: "Ergebnistabelle",
          moreTestCategories: "Weitere Testkategorien",
        },
        table: {
          type: "Testtyp",
          result: "Ergebnis",
        },
        tabs: {
          nad_500: "NAD+ 500",
          tirzepatide_30mg: "Tirzepatid 30mg",
          tirzepatide_10mg: "Tirzepatid 10mg",
          retatrutide_30mg: "Retatrutid 30mg",
          retatrutide: "Retatrutid",
          tirzepatide: "Tirzepatid",
          semaglutide: "Semaglutid",
          ghk_cu: "GHK-Cu",
          glow70: "GLOW70",
          klow80: "KLOW80",
          tb_500: "TB-500",
          melanotan_ii: "Melanotan-II",
          igf1_lr3: "IGF-1 LR3",
          cjc_no_dac: "CJC 1295 ohne DAC",
          ipamorelin: "Ipamorein",
          selank: "Selank",
          semax: "Semax",
        },
        labels: {
          contentMeasured: "Gehalt (gemessen)",
          amountMeasured: "Menge (gemessen)",
          purityHPLC: "Reinheit (HPLC)",
          purity: "Reinheit",
          heavyMetals: "Schwermetalle",
          endotoxins: "Endotoxine",
          laboratory: "Labor",
          taskNumber: "Auftragsnummer",
          verificationCode: "Verifizierungscode",
          analysisDate: "Analysedatum",
          verification: "Verifizierung",
          peptide: "Peptid",
        },
        values: {
          testedWithinSpecs: "Getestet - innerhalb der Spezifikationen",
          underAnalysis: "In Analyse / Bald verfügbar",
          notTested: "Nicht getestet",
          verifyTestReport: "Testbericht verifizieren",
          viewVerifyReport: "Testbericht ansehen und verifizieren",
        },
      },
      calculator: {
        title: "Peptid-Rechner",
        aria: {
          section: "Rechner",
        },
        labels: {
          syringeVolume: "Wie groß ist das Gesamtvolumen Ihrer Spritze?",
          vialMg: "Wie viele mg enthält die Durchstechflasche?",
          waterMl: "Wie viel bakteriostatisches Wasser fügen Sie hinzu?",
          doseMg: "Wie viele mg möchten Sie dosieren?",
        },
        buttons: {
          other: "Andere",
        },
        alt: {
          vial: "Durchstechflasche",
          water: "bakteriostatisches Wasser",
          syringe: "{{v}} ml Spritze",
        },
        result: {
          prefix: "Um eine Dosis von",
          suffix: "zu erhalten, ziehen Sie die Spritze auf",
        },
      },
      help: {
        title: "Hilfe-Center",
        intro1: "Willkommen im Puritybase Hilfe-Center.",
        intro2:
          "Hier finden Sie Antworten auf die am häufigsten gestellten Fragen zu Bestellungen, Versand, Rücksendungen und unseren Produkten.",
        sections: [
          {
            key: "pay", 
            title: "🛒 Bestellung & Zahlung",
            faqs: [
              {
                q: "Welche Zahlungsmethoden bieten Sie an?",
                a: [
                  "Sie können sicher und einfach mit den am weitesten verbreiteten europäischen Zahlungsoptionen bezahlen.",
                  "Alle Zahlungen erfolgen über eine sichere SSL-Verbindung und werden sofort bearbeitet.",
                ],
              },
              {
                q: "Wird meine Zahlung sofort bestätigt?",
                a: [
                  "Ja. Sobald die Zahlung abgeschlossen ist, erhalten Sie automatisch eine <strong>Bestellbestätigung per E-Mail</strong>.",
                  "Haben Sie innerhalb weniger Minuten keine E-Mail erhalten? Überprüfen Sie Ihren Spam-Ordner oder kontaktieren Sie uns.",
                ],
              },
              {
                q: "Wie wird meine Bestellung verpackt?",
                a: [
                  "Alle Bestellungen werden in <strong>diskreter, neutraler Verpackung</strong> ohne außen sichtbare Produktnamen oder Logos versandt.",
                  "Im Inneren werden Ihre Produkte professionell verpackt, um sicherzustellen, dass sie in einwandfreiem Zustand ankommen."
                ],
              },
            ],
          },
          {
            key: "ship", 
            title: "🚚 Versand",
            faqs: [
              {
                q: "In welche Länder versenden Sie?",
                a: [
                  "Wir versenden <strong>aus den Niederlanden</strong> in alle Länder der Europäischen Union.",
                  "Geschätzte Lieferzeiten:",
                  "• <strong>Niederlande & Belgien:</strong> 1-2 Werktage",
                  "• <strong>Deutschland, Frankreich, Luxemburg, Österreich:</strong> 2-4 Werktage",
                  "• <strong>Spanien, Italien, Portugal:</strong> 3-6 Werktage",
                  "• <strong>Skandinavien</strong> (Schweden, Dänemark, Finnland, Norwegen): 4-7 Werktage"
                ],
              },
              {
                q: "Was sind die Versandkosten?",
                a: [
                  "Die Versandkosten werden automatisch an der Kasse berechnet:",
                  "• <strong>Niederlande:</strong> 4,95 €",
                  "• <strong>Belgien:</strong> 9,95 €",
                  "• <strong>Deutschland:</strong> 9,95 €",
                  "• <strong>Frankreich:</strong> 9,95 €",
                  "<br />",
                  "• <strong>Andere europäische Länder:</strong> 14,95 €",
                  "<br />",
                  "<strong>Bestellungen über 250 € werden innerhalb der EU KOSTENLOS versandt!</strong>"
                ],
              },
              {
                q: "Erhalte ich einen Sendungsverfolgungs-Link?",
                a: [
                  "Ja! Sobald Ihre Bestellung versandt wurde, erhalten Sie automatisch eine E-Mail mit dem <strong>Sendungsverfolgungs-Link</strong>, damit Sie Ihr Paket in Echtzeit verfolgen können.",
                ],
              },
              {
                q: "Was passiert bei Verzögerung oder Verlust?",
                a: [
                  "Wenn Ihre Bestellung nicht innerhalb der erwarteten Lieferzeit angekommen ist, kontaktieren Sie uns bitte innerhalb von <strong>10 Werktagen</strong> nach Aufgabe Ihrer Bestellung.",
                  "<br />",
                  "Wir werden sofort eine Untersuchung beim Spediteur einleiten und sicherstellen, dass Sie eine <strong>vollständige Rückerstattung oder einen kostenlosen Ersatzversand</strong> erhalten."
                ],
              },
            ],
          },
          {
            key: "return", 
            title: "↩️ Rücksendungen & Rückerstattungen",
            faqs: [
              {
                q: "Akzeptieren Sie Rücksendungen?",
                a: [
                  "Nein. Wir akzeptieren keine Rücksendungen. Alle Verkäufe sind endgültig. Bitte überprüfen Sie Ihre Bestellung sorgfältig, bevor Sie Ihren Kauf abschließen.",
                ],
              },
              {
                q: "Kann ich eine Rückerstattung erhalten?",
                a: [
                  "Wir gewähren keine Rückerstattungen für Meinungsänderungen oder unerwünschte Artikel. Wenn Ihre Bestellung beschädigt oder fehlerhaft angekommen ist, kontaktieren Sie uns bitte innerhalb von 48 Stunden nach Lieferung mit Fotos und Ihrer Bestellnummer.",
                ],
              },
              {
                q: "Kann ich ein Produkt umtauschen?",
                a: [
                  "Wir bieten keinen Produktaustausch an."
                ],
              },
            ],
          },
          {
            key: "contact", 
            title: "💬 Kontakt & Support",
            faqs: [
              {
                q: "Wie kann ich Sie kontaktieren?",
                a: [
                  "Wir bieten verschiedene Möglichkeiten, uns zu erreichen:",
                  "<br />",
                  "📧 <strong>E-Mail:</strong> info@example.com",
                  "→ Antwort innerhalb von 2-3 Werktagen",
                  "<br />",
                  "📝 <strong>Kontaktformular:</strong> Auf unserer Website",
                  "→ Antwort innerhalb von 2-3 Werktagen",
                  "<br />",
                  "💬 <strong>Telegram:</strong>",
                  "→ Antwort innerhalb von 2-3 Stunden (am schnellsten!)",
                  "<br />",
                  "Für dringende Fragen ist Telegram Ihre beste Option!"
                ],
              },
              {
                q: "Was sind Ihre Geschäftszeiten?",
                a: [
                  "Unser Kundenservice-Team ist erreichbar:",
                  "<br />",
                  "<strong>Montag - Freitag:</strong> 9:00 - 17:00 CET",
                  "<br />",
                  "Der Telegram-Support ist länger verfügbar und antwortet in der Regel viel schneller als E-Mails."
                ],
              },
            ],
          },
        ],
      },
      terms: {
        title: "AGB",
        breadcrumb: "Startseite",
        breadcrumbAria: "Brotkrumen",
        lastUpdated: "Zuletzt aktualisiert: Januar 2025",
        intro:
          "Die folgenden Bestimmungen gelten für Ihre Nutzung dieser Website und jede Bestellung, die Sie aufgeben.",
        sections: [
          {
            title: "1. Allgemeines",
            body: "Diese Allgemeinen Geschäftsbedingungen gelten für alle Angebote, Bestellungen und Vereinbarungen, die über unsere Website getätigt werden.",
          },
          {
            title: "2. Preise",
            body: "Alle Preise sind in Euro und enthalten MwSt. Preise können ohne vorherige Ankündigung geändert werden.",
          },
          {
            title: "3. Bestellung",
            body: "Mit der Aufgabe einer Bestellung stimmen Sie diesen Allgemeinen Geschäftsbedingungen zu.",
          },
          {
            title: "4. Zahlung",
            body: "Die Zahlung muss vor dem Versand erfolgen. Wir akzeptieren verschiedene Zahlungsmethoden, einschließlich iDEAL, Kreditkarte und PayPal.",
          },
          {
            title: "5. Lieferung",
            body: "Wir versenden innerhalb von 1-2 Werktagen. Die Lieferzeiten hängen von Ihrem Standort ab.",
          },
        ],
      },
      refunds: {
        breadcrumb: "Startseite",
        breadcrumbAria: "Brotkrumen",
        badgeBrand: "KING'S ACCESS",
        badgePoints: "214 PTS",
        title: "Rückgabe- und Erstattungsrichtlinie",
        intro:
          "Bei Puritybase haben Qualität, Sicherheit und Kundenzufriedenheit oberste Priorität. Aufgrund der Beschaffenheit unserer Produkte pflegen wir eine strenge, aber faire Richtlinie, die auf Produktsicherheit und schnelle Lösung etwaiger Probleme ausgerichtet ist.",
        sections: [
          {
            title: "Keine Rücksendungen bei Peptiden",
            paragraphs: [
              "Aufgrund der Beschaffenheit von Peptiden und Laborchemikalien sind Rücksendungen nicht möglich. Sobald eine Bestellung versandt wurde, kann das Produkt nicht weiterverkauft oder unter sterilen Bedingungen erneut geprüft werden.",
              "Diese Richtlinie ist notwendig, um die Sicherheit unserer Kunden und die Integrität und Reinheit unserer Produkte zu gewährleisten. Mit der Aufgabe einer Bestellung stimmen Sie dieser Richtlinie zu.",
            ],
          },
          {
            title: "Beschädigte Lieferung oder zerbrochene Durchstechflasche",
            paragraphs: [
              "Wenn Ihre Bestellung beschädigt angekommen ist oder eine zerbrochene Durchstechflasche enthält, kontaktieren Sie uns bitte innerhalb von 48 Stunden nach Lieferung per E-Mail oder <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> und fügen Sie klare Fotos bei.",
              "<strong>Anforderungen:</strong>",
            ],
            list: [
              "Klare Fotos des Produkts",
              "Klare Fotos der Originalverpackung",
              "Klare Fotos des sichtbaren Schadens",
            ],
            paragraphsTail: [
              "In diesen Fällen senden wir kostenlos eine Ersatzlieferung. Dies ist unsere Standardlösung, um Ihnen so schnell wie möglich zu helfen.",
            ],
          },
          {
            title: "Erstattung (nur nach zweiter Lieferung)",
            paragraphs: ["Eine Erstattung ist nur möglich, wenn:"],
            list: [
              "es zwei Lieferungen gegeben hat (die ursprüngliche Lieferung + eine kostenlose Ersatzlieferung), und",
              "wenn es bei der zweiten Lieferung erneut zu einem Problem kommt (z.B. Beschädigung oder zerbrochene Durchstechflasche).",
            ],
            paragraphsTail: [
              "In diesem Ausnahmefall bieten wir eine vollständige Erstattung an.",
              "Mit anderen Worten: Wir senden immer zuerst ein Ersatzprodukt; nur bei wiederholtem Versagen wird eine Erstattung in Betracht gezogen.",
            ],
          },
          {
            title: "Bedingungen für Ersatz und mögliche Erstattung",
            list: [
              "Schaden muss innerhalb von 48 Stunden nach Lieferung gemeldet werden",
              "Fotos des beschädigten Produkts und der Originalverpackung sind erforderlich",
              "Produkte müssen unbenutzt und im Originalzustand sein",
              "In einigen Fällen können Sie aufgefordert werden, den beschädigten Artikel zur Überprüfung zurückzusenden.",
            ],
          },
          {
            title: "Falsch eingegebene Lieferadresse",
            paragraphs: [
              "Überprüfen Sie Ihre Versandinformationen immer sorgfältig. Wenn eine Bestellung aufgrund einer falschen oder unvollständigen Adresse nicht zugestellt werden kann, können wir keinen Ersatz oder keine Erstattung garantieren.",
            ],
          },
          {
            title: "Kontakt",
            paragraphs: [
              "Haben Sie Fragen oder gibt es ein Problem mit Ihrer Bestellung? Bitte kontaktieren Sie uns per E-Mail oder <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a>. Wir helfen Ihnen im Rahmen dieser Richtlinie immer gerne.",
            ],
            email: "info@hgppeps.com",
          },
        ],
      },
      privacy: {
        title: "Datenschutzrichtlinie",
        breadcrumb: "Startseite",
        breadcrumbAria: "Brotkrumen",
        lastUpdated: "Zuletzt aktualisiert: Januar 2025",
        intro: "Ihre Privatsphäre ist uns wichtig.",
        sections: [
          {
            title: "1. Datenerhebung",
            body: "Wir erheben Informationen, die Sie bei der Bestellung angeben, einschließlich Name, E-Mail und Lieferadresse.",
          },
          {
            title: "2. Datennutzung",
            body: "Wir verwenden Ihre Daten zur Bearbeitung von Bestellungen, zum Senden von Updates und zur Verbesserung unserer Dienste.",
          },
          {
            title: "3. Datenschutz",
            body: "Wir implementieren Sicherheitsmaßnahmen zum Schutz Ihrer persönlichen Daten.",
          },
          {
            title: "4. Cookies",
            body: "Wir verwenden Cookies, um Ihr Surferlebnis zu verbessern. Sie können Cookie-Einstellungen in Ihrem Browser verwalten.",
          },
          {
            title: "5. Ihre Rechte",
            body: "Sie haben das Recht, auf Ihre persönlichen Daten zuzugreifen, sie zu korrigieren oder zu löschen. Kontaktieren Sie uns für Anfragen.",
          },
        ],
      },
      shippingPage: {
        breadcrumb: "Startseite",
        breadcrumbAria: "Brotkrumen",
        badgeBrand: "KING'S ACCESS",
        badgePoints: "214 PTS",
        title: "Versandinformationen",
        subtitle: "Schnelle und zuverlässige Lieferung in ganz Europa",
        promoAria: "Kostenloser Versand",
        promoLead: "Kostenloser Versand: ",
        promoDetail: "Bei allen Bestellungen über 250 € innerhalb der EU",
        colDestination: "Ziel",
        colStandard: "Standard",
        colExpress: "Express",
        rows: [
          {
            destination: "Niederlande",
            standardDays: "1-2 Tage",
            standardPrice: "4,95 €",
            express: "",
          },
          {
            destination: "Belgien",
            standardDays: "2-3 Tage",
            standardPrice: "9,95 €",
            express: "",
          },
          {
            destination: "Deutschland",
            standardDays: "2-4 Tage",
            standardPrice: "14,95 €",
            express: "",
          },
          {
            destination: "Andere EU",
            standardDays: "3-7 Tage",
            standardPrice: "14,95 €",
            express: "",
          },
        ],
        processTitle: "Versandprozess",
        processBody:
          "Bestellungen, die vor 14 Uhr an Werktagen aufgegeben werden, werden am selben Tag versandt.",
        trackingTitle: "Sendungsverfolgung",
        trackingBody:
          "Sie erhalten einen Tracking-Link per E-Mail, sobald Ihre Bestellung versandt wurde.",
      },
      contact: {
        title: "Brauchen Sie Hilfe? Wir sind für Sie da",
        intro:
          "Von Produktfragen über Hilfe bei Bestellungen bis hin zu Informationen zur Compliance – unser engagiertes Team steht Ihnen bei jedem Schritt zur Seite.",
        helpBtn: "HILFE-CENTER",
        cards: {
          hoursTitle: "Kundenservice-Öffnungszeiten",
          hoursText:
            "Montag – Freitag: 09:00 – 17:00 (Ausnahme: Feiertage)",
          contactTitle: "Kontakt & Support",
          contactIntro:
            "Unser Kundenservice ist NUR über <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> und <a class='privacy__link' href='" + telegram + "' target='_blank' rel='noopener noreferrer'>Telegram</a> verfügbar!",
          whatsapp: "WhatsApp (1–2 Stunden)",
          telegram: "Telegram (1–2 Stunden)",
        },
      },
      bulk: {
        breadcrumbHome: "Startseite",
        title: "Großbestellungen",
        intro:
          "Sie suchen nach Großbestellungen für Forschungszwecke? Wir liefern größere Mengen für Labore, Wiederverkäufer und Forschungsprojekte. Eine Abholung ist nach Terminvereinbarung ebenfalls möglich.",
        form: {
          title: "Angebot anfordern",
          nameLabel: "Vollständiger Name",
          emailLabel: "E-Mail-Adresse",
          requestLabel: "Ihre Anfrage",
          namePlaceholder: "Ihr Name",
          emailPlaceholder: "sie@beispiel.de",
          requestPlaceholder:
            "Bitte angeben: Produkt(e), gewünschte Menge (mg / Anzahl der Durchstechflaschen) und Präferenz (Versand oder Abholung)",
          submit: "Anfrage senden",
          submitting: "Wird gesendet…",
          submitSuccess: "Vielen Dank — Ihre Anfrage wurde gesendet.",
          submitError: "Etwas ist schiefgelaufen. Bitte versuchen Sie es in einem Moment erneut.",
          requiredStar: "*",
        },
        sections: [
          {
            title: "Für wen sind Großbestellungen geeignet?",
            list: [
              "Labore & Forschungseinrichtungen",
              "Partner / Wiederverkäufer (auf Anfrage)",
              "Größere Forschungsprojekte mit wiederkehrenden Einkäufen",
            ],
          },
          {
            title: "Was Sie von uns erwarten können",
            list: [
              "Gestaffelter Rabatt bei höheren Einkäufen",
              "Konsistente Chargenqualität (wo verfügbar mit Laboregebnissen/COA)",
              "Diskret verpackt oder persönliche Abholung nach Terminvereinbarung",
              "Schnelle Kommunikation und klare Absprachen",
            ],
          },
          {
            title: "Wie funktioniert es?",
            ordered: [
              "Senden Sie Ihre Anfrage mit Produkt(en), Menge und Präferenz (Versand oder Abholung)",
              "Wir prüfen Lagerbestand, Chargen und Optionen",
              "Sie erhalten ein konkurrenzfähiges Angebot + Lieferzeit",
              "Nach Genehmigung arrangieren wir den Versand oder die Abholung",
            ],
          },
          {
            title: "Allgemeiner Mengenrabatt",
            boxed: true,
            paragraphs: ["<strong>Mindestbestellmenge:</strong>"],
            list: [
              "10 Stück pro Produkt: <strong>30% Rabatt</strong>",
              "20 Stück pro Produkt: <strong>35% Rabatt</strong>",
              "30 Stück pro Produkt: <strong>40% Rabatt</strong>",
            ],
            tail: [
              "Eine Kombination mehrerer Produkte kann immer gemeinsam besprochen werden!",
            ],
          },
        ],
      },
      partner: {
        breadcrumbHome: "Startseite",
        title: "Partner werden",
        intro:
          "Partnerschaft mit Puritybase und verdienen Sie Geld mit hochwertigen Forschungsprodukten. Unser Partnerprogramm ist für Kreative, Communities und Fachleute konzipiert, die transparent und professionell zusammenarbeiten möchten.",
        form: {
          title: "Bewerbung als Partner",
          nameLabel: "Vollständiger Name",
          emailLabel: "E-Mail-Adresse",
          platformLabel: "Plattform / Website",
          messageLabel: "Nachricht",
          namePlaceholder: "Ihr Name",
          emailPlaceholder: "sie@beispiel.de",
          platformPlaceholder: "Ihre Website oder Ihr Social-Media-Kanal",
          messagePlaceholder: "Erzählen Sie uns von Ihrer Plattform und Ihrem Publikum",
          submit: "Bewerbung einreichen",
          submitting: "Wird gesendet…",
          submitSuccess: "Vielen Dank — Ihre Bewerbung wurde gesendet.",
          submitError: "Etwas ist schiefgelaufen. Bitte versuchen Sie es in einem Moment erneut.",
          requiredStar: "*",
        },
        sections: [
          {
            title: "Warum Partner werden?",
            list: [
              "Attraktive Provisionen pro erfolgreicher Vermittlung",
              "Echtzeit-Einblick in Klicks, Conversions und Umsatz",
              "Persönliche Affiliate-Links und (optional) Rabattcodes",
              "Schnelle und zuverlässige Auszahlungen",
              "Zusammenarbeit mit einer schnell wachsenden Premium-Marke",
            ],
          },
          {
            title: "Für wen ist dieses Programm?",
            listLead: "Unser Affiliate-Programm eignet sich für:",
            list: [
              "Bildende Content-Ersteller",
              "Fitness-, Biohacking- & Forschungs-Communities",
              "Coaches und informative Plattformen",
              "Websites und Social-Media-Kanäle mit relevanter Zielgruppe",
            ],
          },
          {
            title: "Wie funktioniert es?",
            ordered: [
              "Registrieren Sie sich über unser Partner-Portal",
              "Erhalten Sie Ihren persönlichen Affiliate-Link",
              "Teilen Sie Puritybase auf Ihrer Plattform",
              "Verdienen Sie Provision für jede qualifizierende Bestellung",
            ],
          },
          {
            title: "Transparent & Professionell",
            boxed: true,
            paragraphs: [
              "Wir legen großen Wert auf korrekte Kommunikation, klare Haftungsausschlüsse, Einhaltung von Gesetzen und Vorschriften sowie langfristige Partnerschaften. Kooperationen dienen ausschließlich Informations- und Werbezwecken. Unsere Produkte sind nur für Forschungszwecke (in vitro) bestimmt.",
            ],
          },
        ],
      },
      pd: {
        crumbs: { home: "Startseite", products: "Produkte", category: "Erholung" },
        labels: {
          concentration: "Konzentration (mg)",
          water: "3ml Wasser",
          waterStd: "(standardmäßig beigefügt)",
          needles: "Insulin : Nadeln",
          needlesNone: "Keine",
          needle05: "10x 0,5ml Insulinnadel",
          needle1: "10x 1ml Insulinnadel",
          wipes: "Alkoholtücher",
          yes: "Ja",
          no: "Nein",
          clear: "Löschen",
        },
        purchase: {
          quantity: "Menge",
          price: "Preis",
          decreaseQty: "Menge verringern",
          increaseQty: "Menge erhöhen",
          inStock: "Auf Lager",
          addToCart: "IN DEN WARENKORB",
        },
        shipping: {
          b1: "Lieferung innerhalb von 1 Werktag",
          b2: "Abholung an Abholstelle möglich",
          b3: "Diskret verpackt",
          securePayments: "Sichere Zahlungen",
        },
        cutoff: {
          headline: "Bestellen Sie vor {{time}} für Versand am selben Tag",
          within: "Bestellen Sie innerhalb von",
          hours: "Stunden",
          minutes: "Minuten",
          ordered: "Bestellt",
          shipped: "Versandt",
          delivered: "Geliefert",
          today: "Heute",
          nextDay: "Nächster Tag",
          countryAria: "Lieferland oder -region",
          countryUk: "Vereinigtes Königreich",
          countryNl: "Niederlande",
        },
        tabs: {
          desc: "BESCHREIBUNG",
          ship: "VERSAND & LIEFERUNG",
          lab: "LABORERGEBNISSE",
          use: "VERWENDUNG & HAFTUNGSAUSSCHLUSS",
        },
        desc: {
          p1: "<strong>GHK‑Cu</strong> ist ein kupferbindendes Tripeptid, das aus <strong>3 Aminosäuren</strong> (Glycyl‑L‑histidyl‑L‑lysin) besteht, das an ein Kupferion (Cu<sup>2+</sup>) gebunden ist. Im Forschungskontext ist dieses Molekül bekannt für seine Rolle bei der Zellkommunikation und der regenerativen Forschung.",
          p2: "GHK‑Cu wird in wissenschaftlichen Settings untersucht aufgrund von Interaktionen mit Prozessen im Zusammenhang mit <strong>Gewebeumbau</strong>, <strong>Kollagensynthese</strong>, <strong>Zellreparatur</strong> und oxidativem Stressmanagement.",
          relev: "Forschungsrelevanz",
          list: [
            "Untersucht im Rahmen von Modellen zur Haut- und Bindegewebsregeneration.",
            "Relevanz in Studien zu Kollagen- und Extrazellulärer-Matrix-Prozessen.",
            "Studien zu oxidativem Stress und Zellkommunikation.",
            "Angewandt in experimentellen Forschungsumgebungen zu regenerativen Mechanismen.",
          ],
          specTitle: "Wichtige Spezifikationen",
          specHeadKey: "Merkmal",
          specHeadVal: "Wert / Hinweis",
          specRows: [
            ["Peptidtyp", "Kupferbindendes Tripeptid (GHK‑Cu)"],
            ["Aminosäureanzahl", "3"],
            ["Verfügbare Varianten", "50mg, 100mg"],
          ],
        },
        shipTab: {
          ukRegion: "<strong>Vereinigtes Königreich:</strong> {{nextDay}} · {{price}}",
          nlBeRegion: "<strong>Niederlande & Belgien:</strong> 1–2 Werktage · {{price}}",
          restEurope: "<strong>Rest Europas:</strong> 3–7 Werktage · {{price}}",
          originNote: "Versand aus den Niederlanden · Diskret verpackt · Sendungsverfolgung inklusive",
          freeShippingUk: "<strong>Kostenloser Versand</strong> bei Bestellungen über <strong>{{threshold}}</strong>",
          freeShippingEu: "<strong>Kostenloser Versand</strong> bei Bestellungen über <strong>{{threshold}}</strong>",
        },
        labTab: {
          p1: "Unsere Produkte werden von einem externen Labor unabhängig getestet. Die entsprechenden Testberichte, einschließlich Verifizierungscodes, sind öffentlich zugänglich.",
          link: "Unsere Laboregebnisse ansehen",
        },
        useTab: {
          list: [
            "Nur für <strong>Forschungszwecke</strong> bestimmt.",
            "Nicht für menschlichen Gebrauch, Diagnose oder Behandlung.",
            "Nur zur Verwendung durch qualifiziertes Personal in einer kontrollierten Forschungsumgebung.",
            "Mit dem Kauf dieses Produkts bestätigen Sie, dass Sie diese Bedingungen zur Kenntnis genommen haben und angemessene Forschungspraktiken befolgen.",
          ],
        },
        related: "Verwandte Produkte",
      },
      drawer: {
        ariaCart: "Warenkorb",
        close: "Schließen",
        remove: "Entfernen",
        subtotal: "ZWISCHENSUMME:",
        viewCart: "WARENKORB ANSEHEN",
        checkout: "ZUR KASSE",
        freeShipping: "Sie haben Anspruch auf kostenlosen Versand!",
        freeShippingMore: "Noch {{amount}} für kostenlosen Versand",
        securePayments: "Sichere Zahlungen",
        qtyDecrease: "Menge verringern",
        qtyIncrease: "Menge erhöhen",
      },
      checkout: {
        title: "Zur Kasse",
        aria: {
          billing: "Rechnungsdaten",
          order: "Ihre Bestellung",
          contact: "Kontakt",
          delivery: "Lieferung",
        },
        labels: {
          firstName: "Vorname *",
          lastName: "Nachname *",
          email: "E-Mail-Adresse *",
          country: "Land/Region *",
          phoneOptional: "Telefon (optional)",
          postalCode: "Postleitzahl *",
          province: "Provinz *",
          city: "Stadt *",
          street: "Straße *",
        },
        order: {
          title: "Ihre Bestellung",
          product: "Produkt",
          subtotal: "Zwischensumme",
          shipping: "Versand",
          total: "Gesamt",
          qtyLabel: "Menge",
          shippingMethod: "Versandart",
          carrierLaPoste: "Royal Mail Tracked 24®",
          shippingFree: "Kostenlos",
        },
        payNow: "Jetzt bezahlen",
        validation: {
          email: {
            invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            required: "Bitte geben Sie Ihre E-Mail-Adresse ein",
          },
          firstName: { required: "Bitte geben Sie Ihren Vornamen ein" },
          lastName: { required: "Bitte geben Sie Ihren Nachnamen ein" },
          zipCode: {
            required: "Bitte geben Sie Ihre Postleitzahl ein",
            invalid: "Bitte geben Sie eine gültige Postleitzahl ein",
          },
          state: { required: "Bitte wählen Sie ein Land" },
          city: { required: "Bitte geben Sie Ihre Stadt ein" },
          address: { required: "Bitte geben Sie Ihre Straße und Hausnummer ein" },
          phone: {
            required: "Bitte geben Sie Ihre Telefonnummer ein",
            invalid: "Bitte geben Sie eine gültige Telefonnummer ein",
          },
          totalPositive: "Der Gesamtbetrag muss größer als 0 sein. ",
        },
        messages: {
          paymentConfigLoading:
            "Zahlungskonfiguration wird geladen. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
        },
        errors: {
          paymentError:
            "Zahlungsfehler: {{error}}. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
        },
        login: {
          returning: "Wiederkehrender Kunde?",
          clickToLogin: "Hier klicken zum Anmelden",
          intro1:
            "Wenn Sie bereits bei uns eingekauft haben, geben Sie bitte unten Ihre Daten ein.",
          intro2:
            "Wenn Sie Neukunde sind, gehen Sie bitte zum Abschnitt Rechnungsdaten.",
          password: "Passwort",
          loginBtn: "Anmelden",
          remember: "Angemeldet bleiben",
          forgot: "Passwort vergessen?",
          signOut: "Abmelden",
          errorUnknownEmail:
            "Unbekannte E-Mail-Adresse. Überprüfen Sie es erneut oder versuchen Sie Ihren Benutzernamen.",
          loggedInAs: "Sie sind angemeldet als {{email}}",
        },
        register: {
          clickToRegister: "Hier klicken zur Registrierung",
          intro: "Erstellen Sie ein Konto, um schneller auszuchecken und Ihre Bestellungen zu verfolgen.",
          username: "Benutzername",
          password: "Passwort",
          roleType: "Rollentyp",
          roleSelect: "Rolle auswählen",
          roles: {
            customer: "Kunde",
            researcher: "Forscher",
          },
          registerBtn: "Registrieren",
          success: "Registrierung erfolgreich. Sie können sich jetzt anmelden.",
          errors: {
            emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse ein",
            emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            passwordRequired: "Bitte geben Sie ein Passwort ein",
            roleRequired: "Bitte wählen Sie eine Rolle",
          },
          hintOneOf: "Geben Sie mindestens eines an: Benutzername oder E-Mail",
        },
        agreements: {
          research: "Ich bestätige, dass diese Produkte für die Laborforschung bestimmt sind und nicht für die Anwendung an Mensch oder Tier.",
          nonPrivate: "Ich bestätige, dass ich diese Produkte als Forscher, Laborant oder Student unter Aufsicht und nicht als privater Verbraucher erwerbe.",
          notMedicine: "Ich verstehe, dass diese Substanzen keine zugelassenen Medikamente sind und nicht zur Diagnose, Behandlung, Heilung oder Vorbeugung von Krankheiten bestimmt sind.",
          terms: "Ich stimme den Allgemeinen Geschäftsbedingungen zu",
          offers: "Melden Sie mich für exklusive Angebote an",
          error: "Bitte akzeptieren Sie alle erforderlichen Allgemeinen Geschäftsbedingungen."
        },
        payment: {
          title: "Zahlung",
          subtitle: "Alle Transaktionen sind sicher und verschlüsselt.",
          klarna: "Klarna",
          creditCard: "Mit Karte bezahlen",
          payNow: "Jetzt bezahlen",
          secure: "Sicher und verschlüsselt"
        }
      },
      success: {
        box: {
          thankYou: "Vielen Dank für Ihre Bestellung.",
          difference: "Ihre Bestellung wurde erfolgreich empfangen.",
          confirm:
            "Sie erhalten in Kürze eine Bestellbestätigung über {{channels}}.",
          channels: "E-Mail ({{email}}) oder SMS ({{phone}})",
        },
        share: {
          progress: "Fortschritt teilen",
          sharedCount: "{{count}} mal geteilt",
          inviteText:
            "Entdecken Sie hochwertige Peptide bei Puritybase — Kategorien umfassen Fettabbau, Muskelaufbau, Seren, Hormonelle Unterstützung, Erholung, Kosmetik und Zubehör.",
          return: {
            msg3: "Danke fürs Teilen! Ihre Unterstützung hilft uns, mehr Kunden zu erreichen.",
            msg7: "Danke für die Werbung! Ihre Unterstützung bedeutet uns sehr viel.",
          },
        },
      },
      account: {
        title: "Mein Konto",
        common: {
          loading: "Bitte warten…",
        },
        login: {
          title: "Anmelden",
          email: "E-Mail-Adresse oder Benutzername",
          password: "Passwort",
          remember: "Angemeldet bleiben",
          forgot: "Passwort vergessen?",
          btn: "ANMELDEN",
          loggedInAs: "Sie sind angemeldet als {{email}}",
          signOut: "Abmelden",
          signOutUpper: "ABMELDEN",
        },
        register: {
          title: "Registrieren",
          email: "E-Mail-Adresse",
          password: "Passwort",
          hint: "Ein Link zum Festlegen eines neuen Passworts wird an Ihre E-Mail-Adresse gesendet.",
          btn: "REGISTRIEREN",
          success: "Registrierung erfolgreich! Weiterleitung…",
        },
        errors: {
          emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse oder Ihren Benutzernamen ein",
          passwordRequired: "Bitte geben Sie Ihr Passwort ein",
          unknownEmail:
            "Unbekannte E-Mail-Adresse. Überprüfen Sie es erneut oder versuchen Sie Ihren Benutzernamen.",
          loginFailed: "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten.",
          registerFailed: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        },
      },
      cart: {
        title: "Warenkorb",
        aria: {
          items: "Artikel",
          remove: "Entfernen",
        },
        empty: "Ihr Warenkorb ist leer.",
        table: {
          product: "Produkt",
          price: "Preis",
          qty: "Anzahl",
          subtotal: "Zwischensumme",
        },
        summary: {
          title: "Gesamt:",
          subtotal: "Zwischensumme",
          shipping: "Versand",
          note: "Die Versandoptionen werden an der Kasse aktualisiert.",
          total: "Gesamt",
        },
        checkoutBtn: "ZUR KASSE",
        continueShopping: "Weiter einkaufen",
      },
    },
  },
  // 法国：法语
  fr: {
    translation: {
      header: {
        about: "À propos",
        shop: "Boutique",
        lab: "Résultats de laboratoire",
        calculator: "Calculateur",
        help: "Centre d'aide",
        cartAria: "Panier",
        accountAria: "Compte",
        searchAria: "Rechercher",
        cartTitle: "Panier",
        searchPlaceholder: "Continuez à taper pour rechercher...",
      },
      footer: {
        information: "Informations",
        bestSellers: "Produits les plus vendus",
        cooperation: "Coopération",
        ourSocials: "Nos réseaux sociaux",
        links: {
          calculator: "Calculateur de peptides",
          help: "Centre d’aide",
          terms: "Conditions générales",
          refund: "Politique de retour et de remboursement",
          privacy: "Politique de confidentialité",
          contact: "Contact",
          bulk: "Achats en volume",
          partner: "Devenir partenaire",
          shipping: "Livraison",
        },
        langEnglish: "Anglais",
        langDutch: "Néerlandais",
        langGerman: "Allemand",
        langFrench: "Français",
        promoFreeShip: "Livraison gratuite pour les commandes UE supérieures à €250",
        entryGate: {
          title: "Choisissez vos paramètres",
          subtitle:
            "Nos produits sont destinés uniquement à la recherche. Veuillez respecter la réglementation de votre pays.",
          deliveryCountry: "Pays de livraison",
          language: "Langue",
          searchCountry: "Rechercher des pays...",
          languagePlaceholder: "Choisir une langue...",
          ageQuestion: "Avez-vous 18 ans ou plus ?",
          ageYes: "Oui, j’ai 18 ans ou plus",
          ageNo: "Non",
          researchLabel:
            "Je confirme que ces produits seront utilisés exclusivement à des fins de recherche.",
          continue: "Continuer",
          cookiePrefix:
            "En continuant, vous acceptez l’utilisation des cookies. ",
          privacyPolicy: "Politique de confidentialité",
          accessDeniedTitle: "Accès refusé",
          accessDeniedBody:
            "Vous devez avoir au moins 18 ans pour accéder à ce site.",
          countries: {
            NL: "Pays-Bas",
            BE: "Belgique",
            DE: "Allemagne",
            FR: "France",
            GB: "Royaume-Uni",
          },
        },
      },
      main: {
        hero: {
          title_white: "Peptides de qualité recherche",
          title_yellow: "Pour des résultats constants",
          cta: "Acheter des peptides",
          telegram_title: "Rejoignez notre Telegram",
          telegram_text: "pour des offres exclusives",
        },
        marquee: ["99% PURETÉ", "QUALITÉ NÉERLANDAISE", "UNIQUEMENT À DES FINS DE RECHERCHE"],
        categoriesTitleLight: "Tous",
        categoriesTitleAccent: "Catégories",
        categories: {
          fat_burning: "Brûlage des graisses",
          muscle_building: "Construction musculaire",
          serums: "Sérums",
          mental_focus: "Concentration mentale",
          hormonal_support: "Support hormonal",
          recovery: "Récupération",
          cosmetic: "Cosmétique",
          supplies: "Fournitures",
        },
        productsTitleLight: "Peptides populaires dans notre",
        productsTitleAccent: "Catalogue de recherche",
        productsText: "Tous les composés sont testés par lot et expédiés discrètement",
        viewAll: "Voir tous les peptides",
        priceFrom: "À partir de {{price}}",
        buttons: {
          addToCart: "AJOUTER AU PANIER",
          selectOptions: "SÉLECTIONNER LES OPTIONS",
          view: "VOIR",
          badgeFreeBox: "• BOÎTE DE RANGEMENT POUR PEPTIDES OFFERTE",
        },
        aria: {
          previous: "Précédent",
          next: "Suivant",
          goSlide: "Aller à la diapositive {{n}}",
          goPage: "Aller à la page {{n}}",
          hero: "Hero",
          categories: "Catégories",
          newPeptides: "Nouveaux peptides",
          about: "À propos de Puritybase",
          reasons: "Pourquoi choisir Puritybase",
          telegram: "Rejoignez notre Telegram",
        },
        empty: "Aucun produit trouvé.",
        about: {
          titleLight: "À propos de",
          titleAccent: "Puritybase",
          p1: "Chez Puritybase, nous nous engageons à fournir aux chercheurs des peptides de qualité pharmaceutique répondant aux normes les plus élevées de pureté et de fiabilité. Notre mission est de faire progresser le progrès scientifique en fournissant des produits qui permettent des résultats précis, cohérents et fiables.",
          p2: "Chaque peptide de notre catalogue est testé indépendamment et livré avec un certificat d'analyse (COA) pour garantir la transparence et la confiance. Nous croyons que les chercheurs méritent des produits qui sont non seulement efficaces, mais aussi sûrs, cohérents et soigneusement livrés.",
        },
        reasonsTitleAccent: "Pourquoi les chercheurs choisissent Puritybase",
        reasonsText: [
          "Nous fournissons des peptides fabriqués en Europe avec une pureté vérifiée ≥99%. Chaque lot est testé indépendamment et livré avec un certificat d'analyse.",
          "Rejoignez notre communauté Telegram pour des offres exclusives, des mises à jour de recherche et un support direct de notre équipe.",
        ],
        reasons: [
          { title: "Testé en laboratoire", desc: "Tous les produits testés pour pureté et qualité" },
          { title: "Expédition le jour même", desc: "Livraison rapide partout en Europe" },
          { title: "Conseils de manipulation", desc: "Conseils d'experts sur la manipulation des produits" },
          { title: "Service client", desc: "Support dédié pour toutes les demandes" },
        ],
        telegram: {
          title: "Offres exclusives sur Telegram",
          text: "Rejoignez notre chaîne Telegram et soyez le premier à recevoir des réductions privées, des offres à durée limitée et des informations privilégiées que vous ne trouverez nulle part ailleurs.",
          btn: "Rejoindre",
        },
      },
      aboutPage: {
        hero: {
          aria: "À propos de Puritybase",
          breadcrumbAria: "Fil d'Ariane",
          breadcrumb: "Accueil",
          titlePrefix: "À propos de",
          titleBrand: "Puritybase",
          text: "Chez Puritybase, nous nous engageons à fournir aux chercheurs des peptides de qualité pharmaceutique répondant aux normes les plus strictes de pureté et de fiabilité. Notre mission est de soutenir l'avancement scientifique en offrant des produits qui permettent des résultats précis, cohérents et fiables.",
        },
        pledge: {
          aria: "Notre promesse",
          title: "Notre promesse",
          item1: "Peptides de recherche de qualité pharmaceutique",
          item2: "Livraison sûre et discrète dans toute l'Europe",
          item3: "Puretés vérifiées et lots testés en laboratoire",
          item4: "Service dédié pour soutenir votre recherche",
        },
        why: {
          aria: "Pourquoi choisir Puritybase",
          title: "Pourquoi choisir Puritybase",
          text: "Nous livrons des peptides de qualité pharmaceutique, testés indépendamment et accompagnés d'un certificat d'analyse (COA). Avec une expédition mondiale rapide et discrète, des paiements sécurisés et un emballage professionnel, nous garantissons qualité et confiance à chaque commande. Notre équipe s'engage envers la conformité, la fiabilité et le service client dédié.",
          card1Title: "Intégrité scientifique",
          card1Desc: "Chaque peptide est testé HPLC pour une pureté ≥99%, garantissant des résultats de recherche fiables et reproductibles.",
          card2Title: "Confidentiel et conforme",
          card2Desc: "Uniquement à des fins de recherche. Emballage sécurisé et discret avec pleine conformité réglementaire.",
          card3Title: "Livraison rapide",
          card3Desc: "Recevez un code de suivi dans les 24 heures suivant votre commande.",
        },
      },
      shop: {
        title: "Boutique",
        heroTitle: "Tous les produits",
        heroSubtitle: "Parcourez notre collection complète de peptides de recherche premium.",
        breadcrumb: "Accueil",
        breadcrumbAria: "Fil d'Ariane",
        categoriesAria: "Catégories de produits",
        searchPlaceholder: "Rechercher des produits...",
        sortBy: "Trier par :",
        sortNewest: "Plus récents",
        sortPriceAsc: "Prix: Croissant",
        sortPriceDesc: "Prix: Décroissant",
        viewBtn: "VOIR",
        saleBadge: "Solde",
        promoBanner: "+ BOÎTE DE RANGEMENT POUR PEPTIDES OFFERTE",
        emptyTitle: "Aucun produit trouvé",
        emptyDesc: "Essayez une autre catégorie ou recherche.",
        clearFilters: "Effacer les filtres",
        filtersTitle: "Filtres",
        toggleFiltersAria: "Basculer les filtres",
        productsAria: "Produits",
        selectOptions: "SÉLECTIONNER LES OPTIONS",
        categories: {
          all: "Tous",
          anti_aging: "Anti-âge",
          bundles: "Bundles",
          pens: "Stylos",
          serums: "Sérums",
          fat_burning: "Brûlage des graisses",
          muscle_building: "Construction musculaire",
          recovery: "Récupération",
          cosmetic: "Cosmétique",
          hormonal_support: "Support hormonal",
          mental_focus: "Concentration mentale",
          supplies: "Fournitures",
        },
      },
      lab: {
        title: "Résultats des tests",
        breadcrumb: "Accueil",
        breadcrumbAria: "Fil d'Ariane",
        heroTitle: "Résultats de laboratoire",
        heroSubtitle: "Résultats de tests indépendants par des tiers pour tous nos peptides",
        aria: {
          testCategories: "Catégories de tests",
          reports: "Rapports",
          resultsTable: "Tableau des résultats",
          moreTestCategories: "Plus de catégories de tests",
        },
        table: { type: "Type de test", result: "Résultat" },
        tabs: {
          nad_500: "NAD+ 500",
          tirzepatide_30mg: "Tirzepatide 30mg",
          tirzepatide_10mg: "Tirzepatide 10mg",
          retatrutide_30mg: "Rétatrutide 30mg",
          retatrutide: "Rétatrutide",
          tirzepatide: "Tirzepatide",
          semaglutide: "Sémaglutide",
          ghk_cu: "GHK-Cu",
          glow70: "GLOW70",
          klow80: "KLOW80",
          tb_500: "TB-500",
          melanotan_ii: "Mélanotan-II",
          igf1_lr3: "IGF-1 LR3",
          cjc_no_dac: "CJC 1295 sans DAC",
          ipamorelin: "Ipamoréline",
          selank: "Sélank",
          semax: "Sémax",
        },
        labels: {
          contentMeasured: "Contenu (mesuré)",
          amountMeasured: "Quantité (mesurée)",
          purityHPLC: "Puretés (HPLC)",
          purity: "Puretés",
          heavyMetals: "Métaux lourds",
          endotoxins: "Endotoxines",
          laboratory: "Laboratoire",
          taskNumber: "Numéro de tâche",
          verificationCode: "Code de vérification",
          analysisDate: "Date d'analyse",
          verification: "Vérification",
          peptide: "Peptide",
        },
        values: {
          testedWithinSpecs: "Testé - dans les spécifications",
          underAnalysis: "En cours d'analyse / Bientôt disponible",
          notTested: "Non testé",
          verifyTestReport: "Vérifier le rapport de test",
          viewVerifyReport: "Voir et vérifier le rapport de test",
        },
      },
      calculator: {
        title: "Calculateur de peptides",
        aria: { section: "Calculateur" },
        labels: {
          syringeVolume: "Quel est le volume total de votre seringue ?",
          vialMg: "Combien de mg contient le flacon ?",
          waterMl: "Combien d'eau bactériostatique ajoutez-vous ?",
          doseMg: "Combien de mg voulez-vous doser ?",
        },
        buttons: { other: "Autre" },
        alt: { vial: "flacon", water: "eau bactériostatique", syringe: "seringue de {{v}} ml" },
        result: { prefix: "Pour obtenir une dose de", suffix: "tirez la seringue jusqu'à" },
      },
      help: {
        title: "Centre d'aide",
        intro1: "Bienvenue au Centre d'aide Puritybase.",
        intro2: "Vous trouverez ici les réponses aux questions les plus fréquemment posées sur la commande, l'expédition, les retours et nos produits.",
        sections: [
          {
            key: "pay", 
            title: "🛒 Commande et paiement",
            faqs: [
              {
                q: "Quelles méthodes de paiement proposez-vous ?",
                a: [
                  "Vous pouvez payer en toute sécurité et facilement avec les options de paiement européennes les plus largement utilisées.",
                  "Tous les paiements sont effectués via une connexion SSL sécurisée et sont traités immédiatement."
                ],
              },
              {
                q: "Ma paiement est-il confirmé immédiatement ?",
                a: [
                  "Oui. Dès que le paiement est terminé, vous recevrez automatiquement une <strong>confirmation de commande par e-mail</strong>.",
                  "Vous n'avez pas reçu d'e-mail en quelques minutes ? Vérifiez votre dossier spam ou contactez-nous."
                ],
              },
              {
                q: "Comment ma commande est-elle emballée ?",
                a: [
                  "Toutes les commandes sont expédiées dans un <strong>emballage discret et neutre</strong> sans aucun nom de produit ni logo visible à l'extérieur.",
                  "À l'intérieur, vos produits sont emballés professionnellement pour garantir qu'ils arrivent en parfait état."
                ],
              },
            ],
          },
          {
            key: "ship", 
            title: "🚚 Expédition",
            faqs: [
              {
                q: "Vers quels pays expédez-vous ?",
                a: [
                  "Nous expédions <strong>depuis les Pays-Bas</strong> vers tous les pays de l'Union européenne.",
                  "Délais de livraison estimés :",
                  "• <strong>Pays-Bas et Belgique :</strong> 1-2 jours ouvrables",
                  "• <strong>Allemagne, France, Luxembourg, Autriche :</strong> 2-4 jours ouvrables",
                  "• <strong>Espagne, Italie, Portugal :</strong> 3-6 jours ouvrables",
                  "• <strong>Scandinavie</strong> (Suède, Danemark, Finlande, Norvège) : 4-7 jours ouvrables"
                ],
              },
              { q: "Quels sont les frais d'expédition ?", a: ["Les frais d'expédition sont calculés automatiquement à la caisse.", "Les tarifs suivants s'appliquent aux commandes inférieures à 250 € :", "<ul><li><strong>Pays-Bas :</strong> 4,95 €</li><li><strong>Belgique :</strong> 9,95 €</li><li><strong>Allemagne :</strong> 9,95 €</li><li><strong>France :</strong> 9,95 €</li><br/><li><strong>Autres pays européens :</strong> 14,95 €</li></ul>", "Les commandes égales ou supérieures à <strong>250 €</strong> bénéficient de <strong>l'expédition gratuite automatique</strong> dans l'UE."] },
              { q: "Vais-je recevoir un lien de suivi ?", a: ["Oui, une fois votre commande expédiée, vous recevrez automatiquement un e-mail avec le lien de suivi."] },
              { q: "Que se passe-t-il en cas de retard ou de perte ?", a: ["Dans de rares cas, des retards peuvent survenir avec le transporteur ou les douanes.", "Si vous avez des questions, contactez notre équipe via WhatsApp ou Telegram sur <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> ou <a class='privacy__link' href='" + telegram + "' target='_blank' rel='noopener noreferrer'>Telegram</a> — nous répondons généralement dans un jour ouvrable."] },
              { q: "Des questions sur l'expédition ou votre commande ?", a: ["N'hésitez pas à nous contacter via WhatsApp ou Telegram sur <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> ou <a class='privacy__link' href='" + telegram + "' target='_blank' rel='noopener noreferrer'>Telegram</a> — nous répondons généralement dans un jour ouvrable."] },
            ],
          },
          {
            key: "return", 
            title: "↩️ Retours et droit de rétractation",
            faqs: [
              { q: "Puis-je retourner des produits ?", a: ["Les retours ne sont pas possibles.", "En raison de la nature de nos produits et pour des raisons de sécurité, d'hygiène et d'assurance qualité, les commandes ne peuvent pas être annulées ou retournées après la livraison.", "Tous les produits livrés sont considérés comme définitivement vendus. Cela s'applique en particulier aux produits stériles, scellés ou de laboratoire, ainsi qu'aux produits qui ont été spécialement assemblés ou fournis sur commande.", "En passant une commande, le client accepte cette politique de retour."] },
              { q: "Que faire si ma commande est endommagée ou livrée incorrectement ?", a: ["Veuillez nous contacter dans les 48 heures suivant la réception via WhatsApp ou Telegram sur <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> ou <a class='privacy__link' href='" + telegram + "' target='_blank' rel='noopener noreferrer'>Telegram</a> — nous répondons généralement dans un jour ouvrable."] },
            ],
          },
          {
            key: "contact", 
            title: "💬 Contact & Support",
            faqs: [
              {
                q: "How can I contact you?",
                a: [
                  "We offer multiple ways to reach us:",
                  "<br />",
                  "📧 <strong>Email:</strong> info@example.com",
                  "→ Response within 2-3 business days",
                  "<br />",
                  "📝 <strong>Contact Form:</strong> On our website",
                  "→ Response within 2-3 business days",
                  "<br />",
                  "💬 <strong>Telegram:</strong>",
                  "→ Response within 2-3 hours (fastest!)",
                  "<br />",
                  "For urgent questions, Telegram is your best option!"
                ],
              },
              {
                q: "What are your business hours?",
                a: [
                  "Our customer service team is available:",
                  "<br />",
                  "<strong>Monday - Friday:</strong> 9:00 - 17:00 CET",
                  "<br />",
                  "Telegram support has extended availability and typically responds much faster than email."
                ],
              },
            ],
          },
        ],
      },
      terms: {
        title: "Conditions générales",
        breadcrumb: "Accueil",
        breadcrumbAria: "Fil d'Ariane",
        lastUpdated: "Dernière mise à jour : janvier 2025",
        intro: "Les dispositions suivantes s'appliquent à votre utilisation de ce site Web et à chaque commande que vous passez.",
        sections: [
          { title: "1. Généralités", body: "Les présentes conditions générales s'appliquent à toutes les offres, commandes et accords conclus via notre site Web." },
          { title: "2. Prix", body: "Tous les prix sont en euros et incluent la TVA. Les prix sont sujets à modification sans préavis." },
          { title: "3. Commande", body: "En passant une commande, vous acceptez les présentes conditions générales." },
          { title: "4. Paiement", body: "Le paiement doit être effectué avant l'expédition. Nous acceptons diverses méthodes de paiement, notamment iDEAL, carte de crédit et PayPal." },
          { title: "5. Livraison", body: "Nous expédions dans un délai de 1 à 2 jours ouvrables. Les délais de livraison dépendent de votre localisation." },
        ],
      },
      refunds: {
        breadcrumb: "Accueil",
        breadcrumbAria: "Fil d'Ariane",
        badgeBrand: "KING'S ACCESS",
        badgePoints: "214 PTS",
        title: "Politique de retour et de remboursement",
        intro: "Chez Puritybase, la qualité, la sécurité et la satisfaction du client sont primordiales. En raison de la nature de nos produits, nous maintenons une politique stricte mais équitable axée sur la sécurité des produits et la résolution rapide de tout problème.",
        sections: [
          { title: "Aucun retour sur les peptides", paragraphs: ["En raison de la nature des peptides et des produits chimiques de laboratoire, les retours ne sont pas possibles. Une fois qu'une commande a été expédiée, le produit ne peut pas être revendu ou réinspecté pour des conditions stériles.", "Cette politique est nécessaire pour garantir la sécurité de nos clients et l'intégrité et la pureté de nos produits. En passant une commande, vous acceptez cette politique."] },
          { title: "Livraison endommagée ou flacon cassé", paragraphs: ["Si votre commande est arrivée endommagée ou contient un flacon cassé, veuillez nous contacter dans les 48 heures suivant la livraison par e-mail ou <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> et joignez des photos claires.", "<strong>Exigences :</strong>"], list: ["Photos claires du produit", "Photos claires de l'emballage d'origine", "Photos claires des dommages visibles"], paragraphsTail: ["Dans ces cas, nous enverrons un envoi de remplacement gratuitement. C'est notre solution standard pour vous aider le plus rapidement possible."] },
          { title: "Remboursement (uniquement après le deuxième envoi)", paragraphs: ["Un remboursement n'est possible que si :"], list: ["il y a eu deux envois (l'envoi d'origine + un envoi de remplacement gratuit), et", "s'il y a à nouveau un problème lors du deuxième envoi (par exemple, dommages ou flacon cassé)."], paragraphsTail: ["Dans ce cas exceptionnel, nous offrons un remboursement complet.", "En d'autres termes, nous envoyons toujours d'abord un produit de remplacement ; ce n'est qu'en cas d'échec répété qu'un remboursement sera envisagé."] },
          { title: "Conditions pour le remplacement et le remboursement possible", list: ["Les dommages doivent être signalés dans les 48 heures suivant la livraison", "Des photos du produit endommagé et de l'emballage d'origine sont requises", "Les produits doivent être inutilisés et dans leur état d'origine", "Dans certains cas, il peut vous être demandé de retourner l'article endommagé pour vérification."] },
          { title: "Adresse de livraison mal saisie", paragraphs: ["Vérifiez toujours attentivement vos informations d'expédition. Si une commande ne peut pas être livrée en raison d'une adresse incorrecte ou incomplète, nous ne pouvons pas garantir un remplacement ou un remboursement."] },
          { title: "Contact", paragraphs: ["Vous avez des questions ou un problème avec votre commande ? Veuillez nous contacter par e-mail ou <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a>. Nous sommes toujours heureux de vous aider dans le cadre de cette politique."], email: "info@hgppeps.com" },
        ],
      },
      privacy: {
        title: "Politique de confidentialité",
        breadcrumb: "Accueil",
        breadcrumbAria: "Fil d'Ariane",
        lastUpdated: "Dernière mise à jour : janvier 2025",
        intro: "Votre vie privée est importante pour nous.",
        sections: [
          { title: "1. Collecte de données", body: "Nous collectons les informations que vous fournissez lors de la passation de commandes, y compris le nom, l'e-mail et l'adresse de livraison." },
          { title: "2. Utilisation des données", body: "Nous utilisons vos données pour traiter les commandes, envoyer des mises à jour et améliorer nos services." },
          { title: "3. Protection des données", body: "Nous mettons en œuvre des mesures de sécurité pour protéger vos informations personnelles." },
          { title: "4. Cookies", body: "Nous utilisons des cookies pour améliorer votre expérience de navigation. Vous pouvez gérer les préférences de cookies dans votre navigateur." },
          { title: "5. Vos droits", body: "Vous avez le droit d'accéder, de corriger ou de supprimer vos données personnelles. Contactez-nous pour toute demande." },
        ],
      },
      shippingPage: {
        breadcrumb: "Accueil",
        breadcrumbAria: "Fil d'Ariane",
        badgeBrand: "KING'S ACCESS",
        badgePoints: "214 PTS",
        title: "Informations d'expédition",
        subtitle: "Livraison rapide et fiable dans toute l'Europe",
        promoAria: "Offre de livraison gratuite",
        promoLead: "Livraison gratuite : ",
        promoDetail: "Sur toutes les commandes supérieures à 250 € dans l'UE",
        colDestination: "Destination",
        colStandard: "Standard",
        colExpress: "Express",
        rows: [
          { destination: "Pays-Bas", standardDays: "1-2 jours", standardPrice: "4,95 €", express: "" },
          { destination: "Belgique", standardDays: "2-3 jours", standardPrice: "9,95 €", express: "" },
          { destination: "Allemagne", standardDays: "2-4 jours", standardPrice: "14,95 €", express: "" },
          { destination: "Autre UE", standardDays: "3–7 jours", standardPrice: "14,95 €", express: "" },
        ],
        processTitle: "Processus d'expédition",
        processBody: "Les commandes passées avant 14h les jours ouvrables sont expédiées le jour même.",
        trackingTitle: "Suivi",
        trackingBody: "Vous recevrez un lien de suivi par e-mail dès que votre commande aura été expédiée.",
      },
      contact: {
        title: "Besoin d'aide ? Nous sommes là pour vous",
        intro: "Des questions sur les produits à l'aide pour les commandes ou les informations sur la conformité – notre équipe dédiée est prête à vous guider à chaque étape.",
        helpBtn: "CENTRE D'AIDE",
        cards: {
          hoursTitle: "Heures d'ouverture du service client",
          hoursText: "Lundi – Vendredi : 09h00 – 17h00 (Exception : jours fériés)",
          contactTitle: "Contact et support",
          contactIntro: "Notre service client est UNIQUEMENT disponible sur <a class='privacy__link' href='" + whatsapp + "' target='_blank' rel='noopener noreferrer'>WhatsApp</a> et <a class='privacy__link' href='" + telegram + "' target='_blank' rel='noopener noreferrer'>Telegram</a> !",
          whatsapp: "WhatsApp (1–2 heures)",
          telegram: "Telegram (1–2 heures)",
        },
      },
      bulk: {
        breadcrumbHome: "Accueil",
        title: "Achats en volume",
        intro: "Vous cherchez des achats en volume à des fins de recherche ? Nous fournissons des volumes plus importants pour les laboratoires, les revendeurs et les projets de recherche. Le retrait est également disponible sur rendez-vous.",
        form: {
          title: "Demander un devis",
          nameLabel: "Nom complet",
          emailLabel: "Adresse e-mail",
          requestLabel: "Votre demande",
          namePlaceholder: "Votre nom",
          emailPlaceholder: "vous@exemple.fr",
          requestPlaceholder: "Veuillez inclure : produit(s), quantité souhaitée (mg / nombre de flacons) et préférence (expédition ou retrait)",
          submit: "Envoyer la demande",
          submitting: "Envoi en cours…",
          submitSuccess: "Merci — votre demande a été envoyée.",
          submitError: "Une erreur s'est produite. Veuillez réessayer dans un moment.",
          requiredStar: "*",
        },
        sections: [
          { title: "Pour qui les achats en volume sont-ils adaptés ?", list: ["Laboratoires et institutions de recherche", "Partenaires / revendeurs (sur demande)", "Projets de recherche plus importants avec des achats récurrents"] },
          { title: "Ce que vous pouvez attendre de nous", list: ["Remise progressive pour les achats plus importants", "Qualité de lot constante (où disponible avec résultats de laboratoire/COA)", "Emballage discret ou collecte personnelle sur rendez-vous", "Communication rapide et accords clairs"] },
          { title: "Comment cela fonctionne-t-il ?", ordered: ["Envoyez votre demande avec produit(s), quantité et préférence (expédition ou retrait)", "Nous vérifions le stock, les lots et les options", "Vous recevrez un devis compétitif + délai de livraison", "Après approbation, nous arrangeons l'expédition ou le retrait"] },
          { title: "Remise générale sur le volume", boxed: true, paragraphs: ["<strong>Quantité minimale de commande :</strong>"], list: ["10 pièces par produit : <strong>30% de remise</strong>", "20 pièces par produit : <strong>35% de remise</strong>", "30 pièces par produit : <strong>40% de remise</strong>"], tail: ["Un mélange de plusieurs produits peut toujours être discuté ensemble !"] },
        ],
      },
      partner: {
        breadcrumbHome: "Accueil",
        title: "Devenir partenaire",
        intro: "Partenariat avec Puritybase et gagnez de l'argent grâce à des produits de recherche de haute qualité. Notre programme de partenariat est conçu pour les créateurs, les communautés et les professionnels qui souhaitent collaborer de manière transparente et professionnelle.",
        form: {
          title: "Postuler pour devenir partenaire",
          nameLabel: "Nom complet",
          emailLabel: "Adresse e-mail",
          platformLabel: "Plateforme / Site Web",
          messageLabel: "Message",
          namePlaceholder: "Votre nom",
          emailPlaceholder: "vous@exemple.fr",
          platformPlaceholder: "Votre site Web ou chaîne de réseaux sociaux",
          messagePlaceholder: "Parlez-nous de votre plateforme et de votre audience",
          submit: "Soumettre la candidature",
          submitting: "Envoi en cours…",
          submitSuccess: "Merci — votre candidature a été envoyée.",
          submitError: "Une erreur s'est produite. Veuillez réessayer dans un moment.",
          requiredStar: "*",
        },
        sections: [
          { title: "Pourquoi devenir partenaire ?", list: ["Commissions attractives par recommandation réussie", "Aperçu en temps réel des clics, conversions et revenus", "Liens d'affiliation personnels et codes de réduction (optionnels)", "Paiements rapides et fiables", "Collaboration avec une marque premium en croissance rapide"] },
          { title: "Pour qui ce programme est-il destiné ?", listLead: "Notre programme d'affiliation est adapté pour :", list: ["Créateurs de contenu éducatif", "Communautés fitness, biohacking et recherche", "Coachs et plateformes informatives", "Sites Web et chaînes de réseaux sociaux avec un groupe cible pertinent"] },
          { title: "Comment cela fonctionne-t-il ?", ordered: ["Inscrivez-vous via notre portail partenaires", "Obtenez votre lien d'affiliation personnel", "Partagez Puritybase sur votre plateforme", "Gagnez une commission sur chaque commande éligible"] },
          { title: "Transparent et professionnel", boxed: true, paragraphs: ["Nous accordons une grande importance à une communication correcte, des clauses de non-responsabilité claires, la conformité aux lois et réglementations et les partenariats à long terme. Les collaborations sont uniquement à des fins d'information et de promotion. Nos produits sont destinés uniquement à des fins de recherche (in vitro)."] },
        ],
      },
      pd: {
        crumbs: { home: "Accueil", products: "Produits", category: "Récupération" },
        labels: {
          concentration: "Concentration (mg)",
          water: "eau bactériostatique",
          waterStd: "(fourni en standard)",
          needles: "Insuline : aiguilles",
          needlesNone: "Aucune",
          needle05: "10x aiguille à insuline 0,5ml",
          needle1: "10x aiguille à insuline 1ml",
          wipes: "Lingettes alcoolisées",
          yes: "Oui",
          no: "Non",
          clear: "Supprimer",
        },
        purchase: {
          quantity: "Quantité",
          price: "Prix",
          decreaseQty: "Diminuer la quantité",
          increaseQty: "Augmenter la quantité",
          inStock: "En stock",
          addToCart: "AJOUTER AU PANIER",
        },
        shipping: {
          b1: "Livraison dans 1 jour ouvrable",
          b2: "Retrait au point de collecte disponible",
          b3: "Emballage discret",
          securePayments: "Paiements sécurisés",
        },
        cutoff: {
          headline: "Commandez avant {{time}} pour expédition le jour même",
          within: "Commandez dans",
          hours: "heures",
          minutes: "minutes",
          ordered: "Commandé",
          shipped: "Expédié",
          delivered: "Livré",
          today: "Aujourd'hui",
          nextDay: "Lendemain",
          countryAria: "Pays ou région d'expédition",
          countryUk: "Royaume-Uni",
          countryNl: "Pays-Bas",
        },
        tabs: {
          desc: "DESCRIPTION",
          ship: "EXPÉDITION ET LIVRAISON",
          lab: "RÉSULTATS DE LABORATOIRE",
          use: "UTILISATION ET AVERTISSEMENT",
        },
        desc: {
          p1: "<strong>GHK‑Cu</strong> est un tripeptide fixant le cuivre composé de <strong>3 acides aminés</strong> (glycyl‑L‑histidyl‑L‑lysine) lié à un ion cuivre (Cu<sup>2+</sup>). Dans un contexte de recherche, cette molécule est connue pour son rôle dans la communication cellulaire et la recherche régénérative.",
          p2: "GHK‑Cu est étudié dans des contextes scientifiques en raison d'interactions avec des processus liés au <strong>remodelage tissulaire</strong>, à la <strong>synthèse du collagène</strong>, à la <strong>réparation cellulaire</strong> et à la régulation du stress oxydatif.",
          relev: "Pertinence pour la recherche",
          list: [
            "Étudié dans des modèles concernant la régénération de la peau et des tissus conjonctifs.",
            "Pertinence dans les études sur les processus du collagène et de la matrice extracellulaire.",
            "Étudié en relation avec le stress oxydatif et la communication cellulaire.",
            "Appliqué dans des configurations de recherche expérimentale concernant les mécanismes régénératifs.",
          ],
          specTitle: "Spécifications importantes",
          specHeadKey: "Caractéristique",
          specHeadVal: "Valeur / note",
          specRows: [
            ["Type de peptide", "Tripeptide fixant le cuivre (GHK‑Cu)"],
            ["Nombre d'acides aminés", "3"],
            ["Variantes disponibles", "50mg, 100mg"],
          ],
        },
        shipTab: {
          ukRegion: "<strong>Royaume-Uni :</strong> {{nextDay}} · {{price}}",
          nlBeRegion: "<strong>Pays-Bas et Belgique :</strong> 1–2 jours ouvrables · {{price}}",
          restEurope: "<strong>Reste de l'Europe :</strong> 3–7 jours ouvrables · {{price}}",
          originNote: "Expédition depuis les Pays-Bas · Emballage discret · Suivi inclus",
          freeShippingUk: "<strong>Livraison gratuite</strong> pour les commandes supérieures à <strong>{{threshold}}</strong>",
          freeShippingEu: "<strong>Livraison gratuite</strong> pour les commandes supérieures à <strong>{{threshold}}</strong>",
        },
        labTab: {
          p1: "Nos produits sont testés indépendamment par un laboratoire externe. Les rapports de test correspondants, y compris les codes de vérification, sont accessibles au public.",
          link: "Voir nos résultats de laboratoire",
        },
        useTab: {
          list: [
            "Destiné <strong>uniquement à des fins de recherche</strong>.",
            "Pas pour usage humain, diagnostic ou traitement.",
            "Pour un usage exclusif par du personnel qualifié dans un environnement de recherche contrôlé.",
            "En achetant ce produit, vous confirmez avoir pris connaissance de ces conditions et suivre des pratiques de recherche appropriées.",
          ],
        },
        related: "Produits connexes",
      },
      drawer: {
        ariaCart: "Panier",
        close: "Fermer",
        remove: "Supprimer",
        subtotal: "SOUS-TOTAL :",
        viewCart: "VOIR LE PANIER",
        checkout: "PAYER",
        freeShipping: "Vous êtes éligible à la livraison gratuite !",
        freeShippingMore: "{{amount}} de plus pour la livraison gratuite",
        securePayments: "Paiements sécurisés",
        qtyDecrease: "Diminuer la quantité",
        qtyIncrease: "Augmenter la quantité",
      },
      checkout: {
        title: "Paiement",
        aria: { billing: "Détails de facturation", order: "Votre commande", contact: "Contact", delivery: "Livraison" },
        labels: {
          firstName: "Prénom *",
          lastName: "Nom *",
          email: "Adresse e-mail *",
          country: "Pays/région *",
          phoneOptional: "Téléphone (facultatif)",
          postalCode: "Code postal *",
          province: "Province *",
          city: "Ville *",
          street: "Rue *",
        },
        order: {
          title: "Votre commande",
          product: "Produit",
          subtotal: "Sous-total",
          shipping: "Expédition",
          total: "Total",
          qtyLabel: "Quantité",
          shippingMethod: "Mode d'expédition",
          carrierLaPoste: "Royal Mail Tracked 24®",
          shippingFree: "Gratuit",
        },
        payNow: "Payer maintenant",
        validation: {
          email: { invalid: "Veuillez entrer une adresse e-mail valide", required: "Veuillez entrer votre adresse e-mail" },
          firstName: { required: "Veuillez entrer votre prénom" },
          lastName: { required: "Veuillez entrer votre nom" },
          zipCode: { required: "Veuillez entrer votre code postal", invalid: "Veuillez entrer un code postal valide" },
          state: { required: "Veuillez sélectionner un pays" },
          city: { required: "Veuillez entrer votre ville" },
          address: { required: "Veuillez entrer votre rue et numéro de maison" },
          phone: { required: "Veuillez entrer votre numéro de téléphone", invalid: "Veuillez entrer un numéro de téléphone valide" },
          totalPositive: "Le montant total doit être supérieur à 0. ",
        },
        messages: { paymentConfigLoading: "La configuration de paiement est en cours de chargement. Veuillez patienter un moment et réessayer." },
        errors: { paymentError: "Erreur de paiement : {{error}}. Veuillez réessayer ou contacter le support." },
        login: {
          returning: "Client fidèle ?",
          clickToLogin: "Cliquez ici pour vous connecter",
          intro1: "Si vous avez déjà magasiné chez nous, veuillez entrer vos coordonnées ci-dessous.",
          intro2: "Si vous êtes un nouveau client, veuillez passer à la section Facturation.",
          password: "Mot de passe",
          loginBtn: "Connexion",
          remember: "Se souvenir de moi",
          forgot: "Mot de passe oublié ?",
          signOut: "déconnexion",
          errorUnknownEmail: "Adresse e-mail inconnue. Vérifiez à nouveau ou essayez votre nom d'utilisateur.",
          loggedInAs: "Vous êtes connecté en tant que {{email}}",
        },
        register: {
          clickToRegister: "Cliquez ici pour vous enregistrer",
          intro: "Créez un compte pour payer plus rapidement et suivre vos commandes.",
          username: "Nom d'utilisateur",
          password: "Mot de passe",
          roleType: "Type de rôle",
          roleSelect: "Sélectionnez un rôle",
          roles: { customer: "Client", researcher: "Chercheur" },
          registerBtn: "S'inscrire",
          success: "Inscription réussie. Vous pouvez maintenant vous connecter.",
          errors: {
            emailRequired: "Veuillez entrer votre adresse e-mail",
            emailInvalid: "Veuillez entrer une adresse e-mail valide",
            passwordRequired: "Veuillez entrer un mot de passe",
            roleRequired: "Veuillez sélectionner un rôle",
          },
          hintOneOf: "Fournissez au moins l'un : Nom d'utilisateur ou E-mail",
        },
        agreements: {
          research: "Je confirme que ces produits sont destinés à la recherche en laboratoire et non à une utilisation chez l'homme ou l'animal.",
          nonPrivate: "Je confirme que j'achète ces produits en tant que chercheur, employé de laboratoire ou étudiant sous supervision et non en tant que consommateur privé.",
          notMedicine: "Je comprends que ces substances ne sont pas des médicaments approuvés et ne sont pas destinées à diagnostiquer, traiter, guérir ou prévenir une quelconque maladie.",
          terms: "J'accepte les termes et conditions",
          offers: "Inscrivez-moi aux offres exclusives",
          error: "Veuillez accepter tous les termes et conditions requis."
        },
        payment: {
          title: "Paiement",
          subtitle: "Toutes les transactions sont sécurisées et cryptées.",
          klarna: "Klarna",
          creditCard: "Payer par carte",
          payNow: "Payer maintenant",
          secure: "Sécurisé et crypté"
        }
      },
      success: {
        box: {
          thankYou: "Merci pour votre commande.",
          difference: "Votre commande a été reçue avec succès.",
          confirm: "Vous recevrez une confirmation de commande via {{channels}} sous peu.",
          channels: "e-mail ({{email}}) ou SMS ({{phone}})",
        },
        share: {
          progress: "Progression du partage",
          sharedCount: "Partagé {{count}} fois",
          inviteText: "Découvrez des peptides de haute qualité chez Puritybase — les catégories incluent le brûlage des graisses, la construction musculaire, les sérums, le support hormonal, la récupération, les cosmétiques et les fournitures.",
          return: { msg3: "Merci de partager ! Votre soutien nous aide à atteindre plus de clients.", msg7: "Merci de faire passer le mot ! Votre soutien compte beaucoup pour nous." },
        },
      },
      account: {
        title: "Mon compte",
        common: { loading: "Veuillez patienter…" },
        login: {
          title: "Connexion",
          email: "Adresse e-mail ou nom d'utilisateur",
          password: "Mot de passe",
          remember: "Se souvenir de moi",
          forgot: "Mot de passe oublié ?",
          btn: "CONNEXION",
          loggedInAs: "Vous êtes connecté en tant que {{email}}",
          signOut: "Déconnexion",
          signOutUpper: "DÉCONNEXION",
        },
        register: {
          title: "S'inscrire",
          email: "Adresse e-mail",
          password: "Mot de passe",
          hint: "Un lien pour définir un nouveau mot de passe sera envoyé à votre adresse e-mail.",
          btn: "S'INSCRIRE",
          success: "Inscription réussie ! Redirection…",
        },
        errors: {
          emailRequired: "Veuillez entrer votre adresse e-mail ou nom d'utilisateur",
          passwordRequired: "Veuillez entrer votre mot de passe",
          unknownEmail: "Adresse e-mail inconnue. Vérifiez à nouveau ou essayez votre nom d'utilisateur.",
          loginFailed: "Échec de la connexion. Veuillez vérifier vos identifiants.",
          registerFailed: "L'inscription a échoué. Veuillez réessayer.",
        },
      },
      cart: {
        title: "Panier",
        aria: { items: "Articles", remove: "Supprimer" },
        empty: "Votre panier est vide.",
        table: { product: "Produit", price: "Prix", qty: "Quantité", subtotal: "Sous-total" },
        summary: { title: "Total :", subtotal: "Sous-total", shipping: "Expédition", note: "Les options d'expédition sont mises à jour à la caisse.", total: "Total" },
        checkoutBtn: "PROCÉDER À LA CAISSE",
        continueShopping: "Continuer les achats",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: loadStoredLang() || "de",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
